var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _g, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _rect, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _mask, _g2, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _rect2, _path155, _ellipse, _path156, _ellipse2, _ellipse3, _path157, _path158, _ellipse4, _ellipse5, _path159, _path160, _path161, _path162, _path163, _path164, _rect3, _path165, _path166, _path167, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse0, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _ellipse1, _ellipse10, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _ellipse11, _ellipse12, _path183, _ellipse13, _ellipse14, _path184, _path185, _path186, _mask2, _g3, _path187, _ellipse15, _ellipse16, _circle, _ellipse17, _circle2, _ellipse18, _path188, _rect4, _rect5, _rect6, _g4, _g5, _g6, _path189, _path190, _path191, _g7, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignInUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 518,
    height: 556,
    viewBox: "0 0 518 556",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M461.2 358.044C454.9 358.044 444.8 352.144 439.8 345.944C439.5 345.644 439.6 345.144 439.9 344.944C440.2 344.644 440.7 344.744 440.9 345.044C446.8 352.344 459.2 358.444 463.5 356.044C465.6 354.944 465.1 351.744 464.3 349.344C459.5 334.744 431.7 330.544 431.4 330.544C431 330.444 430.7 330.144 430.8 329.744C430.9 329.344 431.2 329.044 431.6 329.144C432.8 329.344 460.7 333.544 465.7 348.944C467.5 354.344 465.8 356.544 464.2 357.444C463.4 357.744 462.3 358.044 461.2 358.044Z",
    fill: "url(#paint0_radial)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M396.2 324.144L412.8 324.544L457.2 332.044L447.7 332.944L396.2 324.144Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378 396.844L396.2 324.144L447.7 332.944L434.8 409.844L378 396.844Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M434.8 409.844L447.9 405.644L457.2 332.044L445.2 330.644L447.7 332.944L434.8 409.844Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M447.9 405.644L439.3 398.544L434.8 409.844L447.9 405.644Z",
    fill: "#FF9F57"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M439.3 398.544L449.6 331.144L445.2 330.644L447.7 332.944L434.8 409.844L439.3 398.544Z",
    fill: "#811734"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M412.4 334.044C412.1 335.744 410.9 336.844 409.8 336.644C408.7 336.444 408.1 334.844 408.4 333.244C408.7 331.544 409.9 330.444 411 330.644C412.1 330.844 412.7 332.444 412.4 334.044Z",
    fill: "#95295C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M431.6 338.444C431.3 340.144 430.1 341.244 429 341.044C427.9 340.844 427.3 339.244 427.6 337.644C427.9 335.944 429.1 334.844 430.2 335.044C431.4 335.244 432 336.744 431.6 338.444Z",
    fill: "#95295C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M393.9 362.144C391.4 374.444 397.5 386.044 407.5 388.144C417.5 390.144 427.7 381.844 430.2 369.544C432.7 357.244 426.6 345.644 416.6 343.544C406.6 341.544 396.4 349.844 393.9 362.144Z",
    fill: "url(#paint4_linear)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M411.2 334.244C409.5 333.144 408.2 331.844 407 330.444C405.8 329.044 404.7 327.544 403.7 325.944C402.7 324.344 401.9 322.744 401.1 321.044C400.4 319.344 399.6 317.644 399.1 315.844C398.6 314.044 398.4 312.144 398.5 310.144C398.6 308.244 399.2 306.244 400.3 304.544C401.4 302.844 402.9 301.444 404.9 300.644C406.8 299.844 409 299.844 410.9 300.344C412.9 300.844 414.7 302.344 415.7 303.944C416.8 305.644 417.5 307.444 418 309.144C419.1 312.744 419.8 316.244 420.7 319.744C421.6 323.244 422.7 326.544 424.4 329.644C426.1 332.744 428.4 335.444 431.3 337.444C431.6 337.644 431.7 338.144 431.5 338.444C431.3 338.744 430.8 338.844 430.5 338.644C427.4 336.544 424.7 333.744 422.8 330.544C420.9 327.344 419.7 323.744 418.7 320.244C417.7 316.744 417 313.144 415.9 309.744C415.4 308.044 414.7 306.444 413.8 305.044C413.3 304.344 412.8 303.744 412.2 303.344C411.9 303.044 411.6 302.944 411.2 302.744C410.8 302.644 410.5 302.444 410.1 302.344C408.6 301.844 406.9 301.944 405.5 302.444C404 303.044 402.7 304.044 401.8 305.344C400.9 306.644 400.3 308.344 400.1 309.944C400 310.344 400 310.744 400 311.244C400 311.644 400 312.144 400 312.544L400.1 313.844C400.2 314.244 400.3 314.644 400.4 315.144C400.5 316.044 400.9 316.844 401.1 317.644C401.4 318.444 401.8 319.244 402.1 320.144C402.9 321.744 403.7 323.344 404.6 324.844C405.5 326.344 406.6 327.844 407.7 329.144C408.9 330.444 410.2 331.744 411.6 332.544H411.7C412 332.744 412.2 333.244 411.9 333.544C412.1 334.344 411.6 334.444 411.2 334.244C411.3 334.244 411.3 334.244 411.2 334.244Z",
    fill: "url(#paint5_linear)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M401.5 366.844L402.3 362.744L408.6 363.544L409.4 356.644L415.9 357.544L414.2 364.344L421.4 365.244L420.1 371.044L413 369.444L411.1 377.144L407 376.244L408 368.244L401.5 366.844Z",
    fill: "url(#paint6_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_f)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 406,
    r: 8,
    fill: "#FFF4E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1,
    filter: "url(#filter1_f)"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M378.057 149.478C380.111 131.929 396.024 119.393 413.6 121.479C431.177 123.565 443.761 139.483 441.708 157.032L439.768 173.611L376.118 166.057L378.057 149.478Z",
    fill: "url(#paint7_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M413.555 115.871C391.775 113.286 372.057 128.82 369.513 150.566L367.113 171.08C367.109 171.1 367.105 171.12 367.103 171.141C366.771 173.977 384.158 178.372 405.937 180.957C427.717 183.541 445.642 183.337 445.974 180.501C445.975 180.49 445.976 180.48 445.976 180.469L445.98 180.47L448.383 159.926C450.928 138.18 435.334 118.456 413.555 115.871Z",
    fill: "url(#paint8_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M439.773 173.611C439.504 175.903 425.031 176.074 407.446 173.991C389.862 171.909 375.825 168.363 376.094 166.07C376.363 163.778 390.836 163.607 408.42 165.69C426.004 167.772 440.041 171.318 439.773 173.611Z",
    fill: "url(#paint9_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M433.618 173.543C433.436 175.089 421.933 174.997 407.923 173.338C393.914 171.68 382.704 169.082 382.886 167.536C383.067 165.99 394.571 166.081 408.58 167.74C422.589 169.399 433.799 171.997 433.618 173.543Z",
    fill: "url(#paint10_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M445.985 180.469C445.652 183.31 427.718 183.521 405.929 180.941C384.14 178.36 366.746 173.966 367.079 171.125C367.412 168.284 385.346 168.073 407.135 170.653C428.925 173.234 446.318 177.628 445.985 180.469Z",
    fill: "url(#paint11_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M438.376 188.531C438.613 188.345 438.749 188.141 438.774 187.921C439.068 185.412 425.05 181.687 407.464 179.601C389.878 177.515 375.384 177.858 375.09 180.367C375.065 180.587 375.149 180.817 375.337 181.054L375.014 181.016L369.317 229.691C367.261 247.254 379.85 263.183 397.436 265.269C415.022 267.355 430.945 254.808 433.001 237.245L438.698 188.57L438.376 188.531Z",
    fill: "url(#paint12_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M437.768 193.725C438.005 193.538 438.14 193.334 438.166 193.114C438.46 190.605 424.442 186.88 406.855 184.794C389.269 182.708 374.775 183.051 374.481 185.56C374.455 185.78 374.54 186.01 374.727 186.247L374.405 186.208L369.316 229.691C367.26 247.254 379.85 263.183 397.436 265.269C415.022 267.355 430.945 254.808 433.001 237.245L438.09 193.763L437.768 193.725Z",
    fill: "url(#paint13_linear)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M442.22 187.131C442.484 186.916 442.635 186.683 442.665 186.43C443.001 183.555 427.441 179.346 407.91 177.029C388.38 174.713 372.274 175.165 371.937 178.041C371.908 178.293 372.001 178.556 372.208 178.827L371.85 178.784L365.886 229.739C363.603 249.244 377.585 266.935 397.116 269.251C416.646 271.568 434.33 257.634 436.613 238.128L442.578 187.174L442.22 187.131Z",
    fill: "url(#paint14_linear)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M419.34 193.115C414.933 196.371 409.617 199.55 404.349 201.295L404.039 201.398L403.762 201.226C392 193.928 386.768 183.472 384.919 179.074L386.204 178.536C387.985 182.774 393.001 192.797 404.218 199.869C409.196 198.166 414.257 195.138 418.51 191.995C422.855 188.785 426.302 185.497 427.922 183.457L429.014 184.323C427.293 186.492 423.743 189.862 419.34 193.115Z",
    fill: "url(#paint15_linear)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.815 198.549C417.728 202.945 410.393 207.225 403.131 209.563L402.828 209.661L402.555 209.495C386.287 199.588 379.024 185.432 376.454 179.475L377.733 178.925C380.234 184.72 387.279 198.453 403.006 208.139C409.98 205.84 417.063 201.706 422.998 197.42C429.023 193.069 433.811 188.602 436.069 185.815L437.152 186.693C434.791 189.607 429.899 194.156 423.815 198.549Z",
    fill: "url(#paint16_linear)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M362.611 217.081C366.832 217.581 371.584 206.646 373.224 192.658C373.703 188.572 373.863 184.678 373.745 181.199C367.08 184.262 361.141 191.626 357.39 201.404C357.566 210.307 359.516 216.714 362.611 217.081Z",
    fill: "url(#paint17_linear)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M446.836 245.879C444.745 238.685 442.998 228.159 442.148 216.37C441.263 204.1 441.537 193.049 442.686 185.611C449.408 192.834 453.685 205.602 453.31 220.028C453.051 229.96 450.631 238.986 446.836 245.879Z",
    fill: "url(#paint18_linear)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M345.2 170.067C344.215 167.972 345.079 165.128 347.378 165.401C354.061 166.194 358.845 172.247 358.064 178.922C357.514 183.619 354.355 187.372 350.203 188.908C348.512 189.533 347.079 187.892 347.289 186.103C348.01 179.942 347.152 174.218 345.2 170.067Z",
    fill: "url(#paint19_linear)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M345.005 188.948C343.887 198.494 350.727 207.151 360.283 208.284C369.838 209.417 378.491 202.596 379.609 193.05C380.727 183.503 373.888 174.846 364.332 173.713C354.776 172.58 346.123 179.401 345.005 188.948Z",
    fill: "url(#paint20_linear)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M431.816 151.739C431.958 152.085 432.473 152.104 432.516 151.733C432.873 148.681 430.684 145.913 427.627 145.55C424.57 145.187 421.803 147.367 421.446 150.419C421.403 150.79 421.908 150.892 422.126 150.589C423.269 149.001 425.219 148.065 427.304 148.313C429.389 148.56 431.071 149.927 431.816 151.739Z",
    fill: "url(#paint21_linear)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M406.525 150.216C406.423 149.969 406.057 149.956 406.026 150.22C405.773 152.388 407.328 154.355 409.5 154.613C411.672 154.87 413.638 153.322 413.892 151.154C413.923 150.89 413.563 150.817 413.408 151.033C412.596 152.161 411.211 152.825 409.73 152.649C408.248 152.473 407.054 151.503 406.525 150.216Z",
    fill: "url(#paint22_linear)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M392.607 149.601C395.435 149.936 398.996 150.034 399.357 147.213C399.361 147.179 399.365 147.146 399.369 147.112C399.86 142.915 397.471 139.182 394.032 138.774C390.593 138.366 387.407 141.437 386.916 145.634C386.91 145.687 386.904 145.739 386.899 145.792C386.629 148.49 389.91 149.28 392.607 149.601Z",
    fill: "url(#paint23_linear)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M418.621 210.341C418.328 210.306 418.059 210.161 417.875 209.937L410.24 200.692C408.239 198.268 408.65 194.759 411.156 192.869C412.368 191.958 413.887 191.556 415.436 191.739C416.984 191.923 418.37 192.669 419.336 193.839L420.403 195.13L421.738 194.125C422.949 193.212 424.469 192.81 426.019 192.994C427.566 193.177 428.952 193.924 429.918 195.093C431.92 197.517 431.509 201.026 429.003 202.916L419.441 210.124C419.21 210.298 418.916 210.376 418.621 210.341Z",
    fill: "url(#paint24_linear)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M385.949 177.748C386.331 177.794 386.604 178.14 386.559 178.521C386.102 182.425 385.254 192.045 385.515 199.31C385.529 199.694 385.229 200.016 384.845 200.03C384.461 200.043 384.138 199.743 384.124 199.359C383.859 191.988 384.716 182.286 385.177 178.358C385.221 177.976 385.567 177.703 385.949 177.748Z",
    fill: "url(#paint25_linear)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M428.321 182.637C428.703 182.682 428.978 183.008 428.936 183.365C428.508 187.015 427.734 196.014 428.05 202.816C428.066 203.175 427.769 203.474 427.385 203.484C427.001 203.494 426.677 203.21 426.66 202.85C426.339 195.949 427.123 186.875 427.554 183.201C427.595 182.845 427.939 182.592 428.321 182.637Z",
    fill: "url(#paint26_linear)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M413.388 115.573C413.46 111.377 415.71 107.508 416.834 106.076L417.932 106.936C416.914 108.233 414.847 111.816 414.782 115.6L413.388 115.573Z",
    fill: "url(#paint27_linear)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M390.031 202.753C389.718 205.426 387.295 207.335 384.62 207.018C381.945 206.701 380.031 204.277 380.344 201.605C380.657 198.932 383.079 197.023 385.754 197.34C388.429 197.657 390.344 200.081 390.031 202.753Z",
    fill: "url(#paint28_linear)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M425.571 103.273C425.214 106.328 422.445 108.51 419.388 108.147C416.331 107.785 414.142 105.015 414.5 101.961C414.858 98.9069 417.626 96.7247 420.684 97.0871C423.741 97.4495 425.929 100.219 425.571 103.273Z",
    fill: "url(#paint29_linear)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M427.663 202.537C423.93 202.095 420.55 204.759 420.113 208.489L419.989 209.545C419.989 209.546 419.989 209.547 419.989 209.548L419.417 214.429C419.176 216.485 420.649 218.349 422.706 218.593C423.089 218.638 423.435 218.366 423.479 217.984C423.524 217.602 423.251 217.256 422.868 217.211C421.575 217.057 420.649 215.885 420.801 214.593L421.496 208.653C421.844 205.687 424.532 203.568 427.501 203.92C430.47 204.272 432.595 206.961 432.247 209.927L432.124 210.983C432.124 210.984 432.124 210.985 432.123 210.986L431.552 215.868C431.4 217.16 430.229 218.083 428.936 217.93C428.554 217.884 428.208 218.157 428.163 218.539C428.118 218.921 428.392 219.267 428.774 219.312C430.831 219.556 432.695 218.087 432.935 216.032L433.631 210.091C434.068 206.362 431.396 202.98 427.663 202.537Z",
    fill: "url(#paint30_linear)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M417.192 123.642C418.532 128.241 412.521 134.02 403.766 136.55C395.011 139.079 386.828 137.401 385.489 132.802C384.15 128.202 390.161 122.423 398.915 119.894C407.67 117.364 415.853 119.042 417.192 123.642Z",
    fill: "url(#paint31_linear)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M376.617 187.177C377.757 191.092 376.731 194.83 374.324 195.525C371.918 196.22 369.043 193.61 367.903 189.695C366.763 185.78 367.789 182.043 370.195 181.347C372.602 180.652 375.477 183.262 376.617 187.177Z",
    fill: "url(#paint32_linear)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M384.158 133.681C385.371 135.178 384.961 137.516 383.242 138.904C381.523 140.291 379.147 140.203 377.934 138.706C376.722 137.21 377.132 134.872 378.85 133.484C380.569 132.096 382.945 132.185 384.158 133.681Z",
    fill: "url(#paint33_linear)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1,
    filter: "url(#filter2_f)"
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M132.203 278.514L161.606 188.764C166.528 173.739 183.277 166.171 197.806 172.408C210.981 178.063 217.411 193.053 212.429 206.498L179.614 295.057C174.748 308.19 160.078 314.804 147.014 309.755C134.553 304.939 128.044 291.21 132.203 278.514Z",
    fill: "url(#paint34_linear)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M247.593 149.2L171.063 175.314C171.063 175.314 178.851 301.824 205.498 343.124C218.179 349.601 269.057 354.738 304.678 347.425L304.455 348.448C329.457 350.744 380.14 352.686 382.858 342.091C386.254 328.848 387.625 212.302 379.461 193.231C374.94 182.67 363.767 176.746 354.203 173.807C354.219 173.604 354.228 173.501 354.228 173.501L283.864 149.2H247.593Z",
    fill: "url(#paint35_linear)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M310.366 203.664C312.626 202.36 315.41 202.36 317.669 203.664L330.923 211.316C333.182 212.621 334.574 215.032 334.574 217.641V232.945C334.574 235.554 333.182 237.965 330.923 239.27L317.669 246.921C315.41 248.226 312.626 248.226 310.366 246.921L297.113 239.27C294.853 237.965 293.461 235.554 293.461 232.945V217.641C293.461 215.032 294.853 212.621 297.113 211.316L310.366 203.664Z",
    fill: "url(#paint36_linear)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.13 239.461C313.748 239.472 313.377 239.338 313.1 239.086L301.606 228.711C298.593 225.991 298.458 221.43 301.304 218.544C302.68 217.152 304.546 216.352 306.559 216.295C308.572 216.238 310.483 216.931 311.938 218.243L313.543 219.693L315.06 218.156C316.436 216.762 318.301 215.963 320.316 215.906C322.327 215.849 324.239 216.542 325.693 217.854C328.708 220.574 328.843 225.135 325.996 228.021L315.136 239.03C314.874 239.296 314.512 239.45 314.13 239.461Z",
    fill: "url(#paint37_linear)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M197.352 79.563C196.942 77.2849 198.513 74.7616 200.663 75.6202C206.913 78.116 209.967 85.2019 207.484 91.447C205.737 95.8412 201.714 98.6483 197.306 99.0568C195.511 99.2231 194.552 97.2673 195.217 95.5931C197.509 89.829 198.163 84.0777 197.352 79.563Z",
    fill: "url(#paint38_linear)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M180.957 147.121L195.391 95.6926C205.695 92.9086 226.81 90.544 228.836 103.358C228.764 104.108 228.15 105.647 226.276 105.814C227.926 105.681 229.321 108.349 228.708 110.701C228.329 112.154 227.47 112.747 226.826 112.935C227.466 112.977 228.232 113.541 228.234 115.562C228.237 118.821 226.272 120.48 224.839 120.397C226.216 120.621 227.65 121.519 226.361 125.565C225.072 129.612 224.401 132.927 217.096 132.782C215.432 132.749 212.218 133.659 212.18 132.938L204.707 163.837L180.957 147.121Z",
    fill: "url(#paint39_linear)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M217.543 154.237L181.137 292.04C177.222 306.856 161.791 315.462 147.128 311.006C132.869 306.673 124.803 291.62 129.093 277.348L169.882 141.642L217.543 154.237Z",
    fill: "url(#paint40_linear)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M216.883 159.064L241.745 150.776L284.314 148.893L312.944 159.064L302.019 193.344H292.225L299.382 201.632L260.719 248.752L222.156 201.632L226.3 193.344H219.52L216.883 159.064Z",
    fill: "url(#paint41_linear)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M260.479 248.545C250.214 213.981 244.332 168.856 242.673 150.614H284.982C280.916 175.315 270.324 229.482 260.479 248.545Z",
    fill: "url(#paint42_linear)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M253.681 44.329C247.741 44.329 242.925 49.395 242.925 55.6443V151.452L264.039 163.62L284.51 151.452L284.982 127.689H287.969C295.953 125.811 300.565 121.252 300.565 111.373C300.565 101.493 300.565 64.9152 300.565 58.0056C300.565 51.096 294.044 44.329 288.103 44.329H253.681Z",
    fill: "url(#paint43_linear)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M242.925 52.0444C242.925 46.6242 247.319 42.2302 252.739 42.2302H298.847C304.267 42.2302 308.661 46.6242 308.661 52.0444C308.661 57.4647 304.267 61.8586 298.847 61.8586H252.739C247.319 61.8586 242.925 57.4647 242.925 52.0444Z",
    fill: "url(#paint44_linear)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M242.925 103.491C250.245 99.55 255.507 88.6491 255.507 75.8184C255.507 64.1047 251.121 53.9994 244.788 49.3303C243.611 51.1338 242.925 53.3062 242.925 55.6443V103.491Z",
    fill: "url(#paint45_linear)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M256.813 88.6216C256.813 94.6724 252.028 99.5776 246.127 99.5776C240.225 99.5776 235.441 94.6724 235.441 88.6216C235.441 82.5707 240.225 77.6655 246.127 77.6655C252.028 77.6655 256.813 82.5707 256.813 88.6216Z",
    fill: "url(#paint46_linear)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M268.747 107.944C268.747 114.404 280.489 118.908 283.782 108.725L268.747 107.944Z",
    fill: "url(#paint47_linear)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M265.093 99.738C265.093 102.904 261.539 105.471 257.154 105.471C252.77 105.471 249.216 102.904 249.216 99.738C249.216 96.5718 252.77 94.005 257.154 94.005C261.539 94.005 265.093 96.5718 265.093 99.738Z",
    fill: "url(#paint48_linear)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M303.666 99.738C303.666 102.904 300.112 105.471 295.727 105.471C291.343 105.471 287.789 102.904 287.789 99.738C287.789 96.5718 291.343 94.005 295.727 94.005C300.112 94.005 303.666 96.5718 303.666 99.738Z",
    fill: "url(#paint49_linear)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M242.925 149.2L263.953 162.347L284.982 149.2L297.084 153.408L283.834 175.755L263.953 162.347L246.061 175.755L229.845 154.793L242.925 149.2Z",
    fill: "url(#paint50_linear)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M272.45 87.4027C272.45 88.6129 271.469 89.5939 270.259 89.5939C269.049 89.5939 268.068 88.6129 268.068 87.4027C268.068 86.1925 269.049 85.2115 270.259 85.2115C271.469 85.2115 272.45 86.1925 272.45 87.4027Z",
    fill: "url(#paint51_linear)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M292.171 87.4027C292.171 88.6129 291.19 89.5939 289.98 89.5939C288.77 89.5939 287.789 88.6129 287.789 87.4027C287.789 86.1925 288.77 85.2115 289.98 85.2115C291.19 85.2115 292.171 86.1925 292.171 87.4027Z",
    fill: "url(#paint52_linear)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M284.982 141.908L255.507 124.269C259.539 125.51 273.882 129.007 284.982 127.899V141.908Z",
    fill: "url(#paint53_linear)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M278.429 89.4162C278.429 96.5213 272.669 102.281 265.564 102.281C258.459 102.281 252.699 96.5213 252.699 89.4162C252.699 82.3111 258.459 76.5513 265.564 76.5513C272.669 76.5513 278.429 82.3111 278.429 89.4162Z",
    fill: "url(#paint54_linear)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M307.653 89.7718C307.653 96.8769 301.894 102.637 294.789 102.637C287.683 102.637 281.924 96.8769 281.924 89.7718C281.924 82.6667 287.683 76.9069 294.789 76.9069C301.894 76.9069 307.653 82.6667 307.653 89.7718Z",
    fill: "url(#paint55_linear)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M173.139 130.08L221.68 143.929L217.508 158.551L168.967 144.703L173.139 130.08Z",
    fill: "url(#paint56_linear)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1,
    filter: "url(#filter3_f)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 114.009,
    y: 136.948,
    width: 305.447,
    height: 247.332,
    fill: "url(#paint57_linear)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    filter: "url(#filter4_f)"
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M131.146 433.562C129.947 433.562 128.833 434.18 128.199 435.198L79.1242 513.929C78.5525 514.846 78.523 516.002 79.0477 516.947C79.5723 517.892 80.5681 518.478 81.6492 518.478C122.771 518.478 387.671 518.479 428.793 518.479C429.873 518.479 430.869 517.892 431.394 516.947C431.919 516.002 431.889 514.847 431.317 513.93C421.39 498.003 388.466 445.181 382.243 435.198C381.609 434.181 380.495 433.562 379.296 433.562C357.255 433.562 153.187 433.562 131.146 433.562Z",
    fill: "url(#paint58_linear)"
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.51 170.918C387.51 167.441 384.687 164.618 381.21 164.618H120.309C116.832 164.618 114.009 167.441 114.009 170.918V361.603C114.009 365.08 116.832 367.903 120.309 367.903H381.21C384.687 367.903 387.51 365.08 387.51 361.603V170.918Z",
    fill: "url(#paint59_linear)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M442.074 460.863C442.074 458.209 439.92 456.055 437.267 456.055H64.6053C61.9518 456.055 59.7976 458.209 59.7976 460.863V461.126C59.7976 463.779 61.9518 465.934 64.6053 465.934H437.267C439.92 465.934 442.074 463.779 442.074 461.126V460.863Z",
    fill: "url(#paint60_linear)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M325.292 190.827H181.183V305.857H325.292V190.827Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M376.509 350.234C376.51 352.191 374.922 353.782 372.964 353.782L129.01 353.875C127.052 353.876 125.462 352.287 125.461 350.329L125.396 180.064C125.396 178.107 126.984 176.516 128.942 176.516L372.896 176.423C374.854 176.422 376.444 178.011 376.444 179.969L376.509 350.234Z",
    fill: "url(#paint61_linear)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M125.234 182.458L376.822 182.362L376.827 197.845L125.24 197.941L125.234 182.458Z",
    fill: "url(#paint62_linear)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M125.234 176.442L376.821 176.346L376.828 192.464L125.24 192.561L125.234 176.442Z",
    fill: "url(#paint63_linear)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.046 185.408C142.046 187.037 140.726 188.358 139.097 188.358C137.468 188.358 136.147 187.037 136.147 185.408C136.147 183.779 137.468 182.458 139.097 182.458C140.726 182.458 142.046 183.779 142.046 185.408Z",
    fill: "#00EED1"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.24 185.408C151.24 187.037 149.919 188.358 148.29 188.358C146.661 188.358 145.34 187.037 145.34 185.408C145.34 183.779 146.661 182.458 148.29 182.458C149.919 182.458 151.24 183.779 151.24 185.408Z",
    fill: "#FFAC33"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.306 185.408C161.306 187.037 159.985 188.358 158.355 188.358C156.727 188.358 155.405 187.037 155.405 185.408C155.405 183.779 156.727 182.458 158.355 182.458C159.985 182.458 161.306 183.779 161.306 185.408Z",
    fill: "#3395FF"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M240.585 293.006H324.278V308.877H240.585V293.006Z",
    fill: "#149AFF"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M240.792 219.079H323.519V227.14H240.792V219.079Z",
    fill: "#149AFF"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M240.792 240.018H323.519V242.558H240.792V240.018Z",
    fill: "#53DFFF"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M240.792 249.846H282.59V252.386H240.792V249.846Z",
    fill: "#53DFFF"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M240.793 259.675H320.984V262.215H240.793V259.675Z",
    fill: "#53DFFF"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M240.792 269.503H323.519V272.044H240.792V269.503Z",
    fill: "#53DFFF"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M116.061 367.8C114.758 367.799 113.549 368.471 112.86 369.576L59.5581 455.089C58.9371 456.086 58.9051 457.341 59.4749 458.367C60.0447 459.394 61.1263 460.031 62.3006 460.031C106.964 460.03 394.683 460.031 439.347 460.031C440.52 460.031 441.602 459.394 442.172 458.368C442.742 457.341 442.71 456.086 442.089 455.09C431.306 437.791 395.546 380.42 388.787 369.576C388.098 368.471 386.888 367.8 385.586 367.8C361.646 367.8 140 367.799 116.061 367.8Z",
    fill: "url(#paint64_linear)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.455 388.886H114.008L119.97 378.329H144.308L139.455 388.886Z",
    fill: "#001798"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.459 388.886H145.011L149.622 378.329H173.96L170.459 388.886Z",
    fill: "#001798"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.462 388.886H176.015L179.273 378.329H203.611L201.462 388.886Z",
    fill: "#001798"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.466 388.886H207.019L208.925 378.329H233.263L232.466 388.886Z",
    fill: "#001798"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.473 388.886H238.025L238.58 378.329H262.918L263.473 388.886Z",
    fill: "#001798"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.478 388.886H269.031L268.233 378.329H292.571L294.478 388.886Z",
    fill: "#001798"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M325.483 388.886H300.036L297.887 378.329H322.225L325.483 388.886Z",
    fill: "#001798"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M356.488 388.886H331.041L327.54 378.329H351.878L356.488 388.886Z",
    fill: "#001798"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.493 388.886H362.046L357.193 378.329H381.531L387.493 388.886Z",
    fill: "#001798"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.874 405.389H104.692L111.474 393.381H137.393L131.874 405.389Z",
    fill: "#001798"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.992 405.389H137.811L143.055 393.381H168.974L164.992 405.389Z",
    fill: "#001798"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.104 405.389H170.923L174.63 393.381H200.549L198.104 405.389Z",
    fill: "#001798"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.223 405.389H204.042L206.211 393.381H232.13L231.223 405.389Z",
    fill: "#001798"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.34 405.389H237.158L237.79 393.381H263.708L264.34 405.389Z",
    fill: "#001798"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297.458 405.389H270.276L269.37 393.381H295.288L297.458 405.389Z",
    fill: "#001798"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M330.575 405.389H303.394L300.95 393.381H326.868L330.575 405.389Z",
    fill: "#001798"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M363.693 405.389H336.512L332.53 393.381H358.449L363.693 405.389Z",
    fill: "#001798"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M396.811 405.389H369.63L364.11 393.381H390.029L396.811 405.389Z",
    fill: "#001798"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.182 424.302H94.0139L101.797 410.521H129.517L123.182 424.302Z",
    fill: "#001798"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.718 424.302H129.55L135.568 410.521H163.288L158.718 424.302Z",
    fill: "#001798"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.259 424.302H165.091L169.345 410.521H197.065L194.259 424.302Z",
    fill: "#001798"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.795 424.302H200.627L203.116 410.521H230.836L229.795 424.302Z",
    fill: "#001798"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.337 424.302H236.168L236.892 410.521H264.612L265.337 424.302Z",
    fill: "#001798"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M300.87 424.302H271.702L270.662 410.521H298.381L300.87 424.302Z",
    fill: "#001798"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M336.41 424.302H307.241L304.436 410.521H332.156L336.41 424.302Z",
    fill: "#001798"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.949 424.302H342.781L338.211 410.521H365.93L371.949 424.302Z",
    fill: "#001798"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M407.488 424.302H378.32L371.985 410.521H399.705L407.488 424.302Z",
    fill: "#001798"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.122 446.157H81.653L90.6771 430.179H120.466L113.122 446.157Z",
    fill: "#001798"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.461 446.157H119.992L126.97 430.179H156.76L151.461 446.157Z",
    fill: "#001798"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.882 446.157H158.334L163.266 430.179H301.993L304.882 446.157Z",
    fill: "#001798"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M343.164 446.157H311.695L308.443 430.179H338.232L343.164 446.157Z",
    fill: "#001798"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M381.51 446.157H350.042L344.742 430.179H374.532L381.51 446.157Z",
    fill: "#001798"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M419.851 446.157H388.383L381.038 430.179H410.827L419.851 446.157Z",
    fill: "#001798"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.455 387.367H114.008L119.97 376.81H144.308L139.455 387.367Z",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.459 387.367H145.011L149.622 376.81H173.96L170.459 387.367Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.462 387.367H176.015L179.273 376.81H203.611L201.462 387.367Z",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.466 387.367H207.019L208.925 376.81H233.263L232.466 387.367Z",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.473 387.367H238.025L238.58 376.81H262.918L263.473 387.367Z",
    fill: "white"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.478 387.367H269.031L268.233 376.81H292.571L294.478 387.367Z",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M325.483 384.28H300.036L297.887 373.724H322.225L325.483 384.28Z",
    fill: "url(#paint65_linear)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M356.488 387.367H331.041L327.54 376.81H351.878L356.488 387.367Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.493 387.367H362.046L357.193 376.81H381.531L387.493 387.367Z",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.874 400.783H104.692L111.474 388.775H137.393L131.874 400.783Z",
    fill: "url(#paint66_linear)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.992 403.87H137.811L143.055 391.862H168.974L164.992 403.87Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.104 403.87H170.923L174.63 391.862H200.549L198.104 403.87Z",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.223 403.87H204.042L206.211 391.862H232.13L231.223 403.87Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.34 403.87H237.158L237.79 391.862H263.708L264.34 403.87Z",
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297.458 403.87H270.276L269.37 391.862H295.288L297.458 403.87Z",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M330.575 403.87H303.394L300.95 391.862H326.868L330.575 403.87Z",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M363.693 403.87H336.512L332.53 391.862H358.449L363.693 403.87Z",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M396.811 403.87H369.63L364.11 391.862H390.029L396.811 403.87Z",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.182 422.783H94.0139L101.797 409.002H129.517L123.182 422.783Z",
    fill: "url(#paint67_linear)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.718 422.783H129.55L135.568 409.002H163.288L158.718 422.783Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.259 419.697H165.091L169.345 405.916H197.065L194.259 419.697Z",
    fill: "url(#paint68_linear)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.795 422.783H200.627L203.116 409.002H230.836L229.795 422.783Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.337 422.783H236.168L236.892 409.002H264.612L265.337 422.783Z",
    fill: "white"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M300.87 422.783H271.702L270.662 409.002H298.381L300.87 422.783Z",
    fill: "white"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M336.41 422.783H307.241L304.436 409.002H332.156L336.41 422.783Z",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.949 422.783H342.781L338.211 409.002H365.93L371.949 422.783Z",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M407.488 422.783H378.32L371.985 409.002H399.705L407.488 422.783Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.122 444.685H81.653L90.6771 428.707H120.466L113.122 444.685Z",
    fill: "white"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.461 444.685H119.992L126.97 428.707H156.76L151.461 444.685Z",
    fill: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.882 441.551H158.334L163.266 425.573H301.993L304.882 441.551Z",
    fill: "url(#paint69_linear)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M343.164 444.685H311.695L308.443 428.707H338.232L343.164 444.685Z",
    fill: "white"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M381.51 444.685H350.042L344.742 428.707H374.532L381.51 444.685Z",
    fill: "white"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M419.851 444.685H388.383L381.038 428.707H410.827L419.851 444.685Z",
    fill: "url(#paint70_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.2,
    filter: "url(#filter5_f)"
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2543 151.167L147.972 404.859H347.328L491.161 151.167H16.2543Z",
    fill: "url(#paint71_linear)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4601 277.699L137.937 201.266C147.224 188.471 165.486 186.396 177.406 196.782C188.216 206.201 189.747 222.44 180.887 233.713L122.526 307.967C113.872 318.979 97.8815 320.782 86.9916 311.975C76.6042 303.574 74.6128 288.511 82.4601 277.699Z",
    fill: "#A5D9FF"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.723 158.752L147.193 184.867C147.193 184.867 160.5 314.823 175 358.5C178.216 368.186 259.438 371.569 294.514 359.041C320.813 360.596 356.712 360.514 358.987 351.643C362.384 338.4 363.755 221.855 355.591 202.784C351.07 192.223 339.897 186.298 330.334 183.359C330.349 183.157 330.357 183.053 330.357 183.053L259.993 158.752H223.723Z",
    fill: "url(#paint72_linear)"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 147,
    y: 158,
    width: 215,
    height: 203
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.723 158.752L147.193 184.867C147.193 184.867 154.98 311.376 181.628 352.676C194.309 359.153 245.187 364.29 280.808 356.977L280.584 358.001C305.587 360.296 356.27 362.239 358.987 351.644C362.384 338.4 363.755 221.855 355.591 202.784C351.07 192.222 339.896 186.298 330.332 183.359C330.349 183.157 330.357 183.053 330.357 183.053L259.993 158.752H223.723Z",
    fill: "url(#paint73_linear)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.395 279.769C317.416 290.21 309.286 337.686 305.344 360.118C306.975 360.118 314.724 361.478 318.395 362.158C319.347 338.365 320.679 288.579 318.395 279.769Z",
    fill: "url(#paint74_linear)"
  }))), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M286.496 213.217C288.755 211.912 291.539 211.912 293.799 213.217L307.052 220.868C309.312 222.173 310.704 224.584 310.704 227.193V242.497C310.704 245.106 309.312 247.517 307.052 248.822L293.799 256.474C291.539 257.778 288.755 257.778 286.496 256.474L273.242 248.822C270.983 247.517 269.591 245.106 269.591 242.497V227.193C269.591 224.584 270.983 222.173 273.242 220.868L286.496 213.217Z",
    fill: "#FFC56A"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.259 249.013C289.878 249.024 289.507 248.89 289.23 248.638L277.736 238.263C274.723 235.543 274.588 230.982 277.434 228.096C278.81 226.704 280.675 225.904 282.688 225.847C284.701 225.79 286.613 226.483 288.067 227.795L289.673 229.245L291.19 227.708C292.565 226.315 294.431 225.515 296.446 225.458C298.457 225.401 300.369 226.094 301.823 227.406C304.837 230.127 304.973 234.687 302.126 237.573L291.266 248.582C291.003 248.848 290.642 249.002 290.259 249.013Z",
    fill: "#FF3E1D"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M155.852 85.6453C155.589 83.3458 157.317 80.9275 159.408 81.9212C165.486 84.8097 168.083 92.0756 165.208 98.15C163.184 102.424 158.991 104.97 154.566 105.097C152.764 105.148 151.931 103.135 152.702 101.507C155.356 95.9005 156.374 90.2025 155.852 85.6453Z",
    fill: "url(#paint75_linear)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M135.191 152.023L152.869 101.618C163.33 99.495 184.552 98.479 185.758 111.396C185.638 112.14 184.929 113.637 183.047 113.684C184.702 113.656 185.925 116.408 185.163 118.716C184.692 120.142 183.798 120.679 183.142 120.826C183.779 120.908 184.508 121.52 184.381 123.537C184.177 126.789 182.11 128.32 180.685 128.146C182.045 128.457 183.419 129.444 181.875 133.401C180.331 137.357 179.45 140.623 172.17 140.013C170.511 139.875 167.246 140.578 167.254 139.856L157.829 170.217L135.191 152.023Z",
    fill: "url(#paint76_linear)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M171.251 161.453L126.148 296.659C121.298 311.196 105.35 318.803 91.0011 313.423C77.0463 308.191 69.9547 292.656 75.1442 278.685L124.487 145.851L171.251 161.453Z",
    fill: "#A5D9FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    }
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M190 170.084L216.141 161.867L260.898 160L291 170.084L279.514 204.069H269.216L276.741 212.285L236.09 259L195.545 212.285L199.902 204.069H192.773L190 170.084Z",
    fill: "url(#paint77_linear)"
  }))), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M193.012 168.616L217.875 160.328L260.443 158.445L289.073 168.616L278.149 202.897H268.354L275.512 211.184L236.849 258.305L198.286 211.184L202.43 202.897H195.649L193.012 168.616Z",
    fill: "url(#paint78_linear)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M236.609 258.097C226.344 223.533 220.461 178.408 218.803 160.166H261.111C257.046 184.867 246.454 239.034 236.609 258.097Z",
    fill: "url(#paint79_linear)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M229.811 53.8812C223.87 53.8812 219.054 58.9473 219.054 65.1965L219.054 161.004L240.169 173.172L260.639 161.004L261.111 137.242H264.098C272.083 135.363 276.694 130.805 276.694 120.925C276.694 111.046 276.694 74.4675 276.694 67.5579C276.694 60.6483 270.174 53.8812 264.233 53.8812H229.811Z",
    fill: "url(#paint80_linear)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 219.054,
    y: 51.7825,
    width: 65.7363,
    height: 19.6284,
    rx: 9.81421,
    fill: "url(#paint81_linear)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M219.054 113.043C226.375 109.102 231.637 98.2014 231.637 85.3706C231.637 73.6569 227.251 63.5516 220.917 58.8825C219.741 60.686 219.054 62.8585 219.054 65.1966V113.043Z",
    fill: "#003F66"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 222.256,
    cy: 98.1738,
    rx: 10.6862,
    ry: 10.956,
    fill: "url(#paint82_linear)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M244.877 117.496C244.877 123.956 256.619 128.46 259.911 118.277L244.877 117.496Z",
    fill: "#FF8B77"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 233.284,
    cy: 109.29,
    rx: 7.93853,
    ry: 5.73296,
    fill: "#FFB9AE"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 271.857,
    cy: 109.29,
    rx: 7.93854,
    ry: 5.73296,
    fill: "#FFB9AE"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.87 97.2791C256.364 97.0471 256.952 97.2596 257.184 97.7538C257.557 98.5465 258.02 99.4292 258.509 100.363C258.534 100.41 258.559 100.459 258.585 100.507C259.097 101.483 259.631 102.508 260.086 103.488C260.537 104.461 260.932 105.437 261.146 106.315C261.349 107.15 261.447 108.117 261.033 108.918C260.2 110.53 258.582 111.093 257.206 111.157C256.509 111.19 255.821 111.101 255.227 110.931C254.654 110.768 254.074 110.502 253.669 110.11C253.277 109.73 253.267 109.104 253.647 108.712C254.026 108.32 254.652 108.309 255.045 108.689C255.123 108.765 255.356 108.912 255.77 109.03C256.163 109.142 256.636 109.205 257.114 109.183C258.09 109.137 258.887 108.764 259.277 108.01C259.346 107.876 259.404 107.517 259.225 106.783C259.057 106.093 258.726 105.256 258.292 104.32C257.861 103.39 257.348 102.407 256.833 101.425C256.806 101.372 256.778 101.319 256.75 101.266C256.268 100.346 255.786 99.4277 255.395 98.5941C255.163 98.0999 255.375 97.5112 255.87 97.2791Z",
    fill: "#003F66"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M219.054 158.752L240.083 171.899L261.111 158.752L273.213 162.961L259.963 185.308L240.083 171.899L222.191 185.308L205.974 164.345L219.054 158.752Z",
    fill: "white"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 246.389,
    cy: 96.9549,
    rx: 2.19122,
    ry: 2.19121,
    fill: "#003F66"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 266.11,
    cy: 96.9549,
    rx: 2.19122,
    ry: 2.19121,
    fill: "#003F66"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.134 82.6392C246.571 82.043 250.068 83.3583 251.418 84.0885C252.046 84.4279 252.28 85.2119 251.941 85.8396C251.601 86.4674 250.817 86.7011 250.19 86.3618C249.108 85.7772 246.22 84.7267 243.576 85.1853C240.895 85.6503 239.046 87.2649 238.533 87.9037C238.086 88.4599 237.273 88.5483 236.716 88.1012C236.16 87.6541 236.072 86.8408 236.519 86.2846C237.357 85.2417 239.733 83.2291 243.134 82.6392Z",
    fill: "black"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.795 83.0241C266.056 82.9371 263.504 84.3357 262.538 85.0483C261.963 85.472 261.841 86.2809 262.265 86.8551C262.689 87.4294 263.497 87.5515 264.072 87.1278C264.791 86.597 266.779 85.5455 268.713 85.607C270.685 85.6696 272.173 86.6467 272.58 87.0286C273.1 87.517 273.918 87.491 274.406 86.9707C274.894 86.4504 274.868 85.6327 274.348 85.1443C273.563 84.4075 271.498 83.11 268.795 83.0241Z",
    fill: "black"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M261.111 151.461L231.637 133.822C235.669 135.062 250.012 138.56 261.111 137.451V151.461Z",
    fill: "#FF8E53"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.694 109.234C247.363 109.234 251.959 104.638 251.959 98.9684C251.959 93.2992 247.363 88.7033 241.694 88.7033C236.025 88.7033 231.429 93.2992 231.429 98.9684C231.429 104.638 236.025 109.234 241.694 109.234ZM241.694 111.833C248.799 111.833 254.559 106.074 254.559 98.9684C254.559 91.8633 248.799 86.1035 241.694 86.1035C234.589 86.1035 228.829 91.8633 228.829 98.9684C228.829 106.074 234.589 111.833 241.694 111.833Z",
    fill: "#FB8200"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.918 109.589C276.588 109.589 281.183 104.993 281.183 99.3241C281.183 93.6548 276.588 89.0589 270.918 89.0589C265.249 89.0589 260.653 93.6548 260.653 99.3241C260.653 104.993 265.249 109.589 270.918 109.589ZM270.918 112.189C278.023 112.189 283.783 106.429 283.783 99.3241C283.783 92.2189 278.023 86.4591 270.918 86.4591C263.813 86.4591 258.053 92.2189 258.053 99.3241C258.053 106.429 263.813 112.189 270.918 112.189Z",
    fill: "#FB8200"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.993 133.859C231.117 133.402 231.587 133.132 232.044 133.256C237.048 134.614 245.006 136.244 252.59 136.719C256.383 136.956 260.052 136.903 263.197 136.394C266.36 135.884 268.891 134.929 270.513 133.45C270.862 133.131 271.404 133.156 271.723 133.506C272.042 133.855 272.017 134.397 271.667 134.716C269.687 136.522 266.77 137.553 263.47 138.086C260.154 138.622 256.346 138.671 252.483 138.429C244.755 137.945 236.68 136.29 231.595 134.91C231.139 134.786 230.869 134.315 230.993 133.859Z",
    fill: "#003F66"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 128.473,
    y: 134.519,
    width: 50.4774,
    height: 15.2056,
    transform: "rotate(19.5719 128.473 134.519)",
    fill: "#FB8200"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M323.579 228.266C320.61 254.616 318.013 302.861 304.652 359.27",
    stroke: "url(#paint83_linear)",
    strokeWidth: 1.73323
  }))), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M353.84 153.47C356.057 134.519 373.24 120.983 392.22 123.236C411.199 125.488 424.788 142.676 422.571 161.626L420.476 179.529L351.746 171.372L353.84 153.47Z",
    fill: "url(#paint84_linear)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M392.171 117.18C368.653 114.389 347.361 131.163 344.614 154.645L342.022 176.796C342.017 176.817 342.014 176.839 342.011 176.861C341.653 179.924 360.427 184.67 383.945 187.46C407.463 190.251 426.818 190.031 427.177 186.968C427.178 186.957 427.179 186.946 427.18 186.934L427.184 186.935L429.779 164.752C432.526 141.27 415.688 119.971 392.171 117.18Z",
    fill: "url(#paint85_radial)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    cx: 363.248,
    cy: 159.412,
    rx: 10.5208,
    ry: 6.19053,
    transform: "rotate(14.0391 363.248 159.412)",
    fill: "#FFB9AE"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    cx: 409.605,
    cy: 163.991,
    rx: 10.8264,
    ry: 6.17124,
    fill: "#FFB9AE"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 34.6208,
    ry: 4.51299,
    transform: "matrix(0.993061 0.117599 -0.116454 0.993196 386.1 175.457)",
    fill: "url(#paint86_linear)"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 27.5818,
    ry: 3.04328,
    transform: "matrix(0.993063 0.117586 -0.116467 0.993195 386.444 176.212)",
    fill: "url(#paint87_linear)"
  })), _ellipse0 || (_ellipse0 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 42.8996,
    ry: 5.59218,
    transform: "matrix(0.993061 0.117599 -0.116454 0.993196 384.587 181.889)",
    fill: "url(#paint88_linear)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M418.973 195.64C419.229 195.438 419.375 195.218 419.403 194.98C419.72 192.271 404.583 188.249 385.594 185.996C366.605 183.744 350.953 184.114 350.636 186.824C350.608 187.062 350.7 187.31 350.902 187.566L350.554 187.524L344.402 240.085C342.182 259.05 355.776 276.25 374.766 278.502C393.755 280.755 410.949 267.206 413.169 248.241L419.321 195.681L418.973 195.64Z",
    fill: "url(#paint89_linear)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M418.316 201.248C418.572 201.046 418.718 200.826 418.746 200.588C419.063 197.879 403.926 193.857 384.936 191.604C365.947 189.351 350.295 189.721 349.978 192.431C349.95 192.669 350.042 192.917 350.244 193.173L349.896 193.131L344.4 240.085C342.181 259.049 355.775 276.25 374.765 278.502C393.755 280.755 410.949 267.207 413.168 248.242L418.664 201.289L418.316 201.248Z",
    fill: "url(#paint90_linear)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M423.123 194.128C423.409 193.896 423.572 193.643 423.604 193.371C423.967 190.266 407.165 185.721 386.076 183.22C364.986 180.718 347.595 181.207 347.232 184.312C347.2 184.584 347.3 184.868 347.524 185.16L347.138 185.114L340.697 240.136C338.232 261.198 353.33 280.301 374.419 282.802C395.509 285.304 414.604 270.258 417.069 249.195L423.51 194.174L423.123 194.128Z",
    fill: "url(#paint91_radial)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M398.417 200.59C393.659 204.105 387.918 207.538 382.23 209.422L381.896 209.533L381.596 209.347C368.895 201.467 363.246 190.177 361.249 185.427L362.637 184.847C364.56 189.423 369.977 200.246 382.089 207.883C387.464 206.044 392.929 202.773 397.521 199.38C402.213 195.914 405.936 192.363 407.685 190.16L408.864 191.096C407.005 193.437 403.172 197.077 398.417 200.59Z",
    fill: "#299AFF"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M403.25 206.457C396.677 211.204 388.756 215.825 380.915 218.35L380.587 218.456L380.293 218.277C362.727 207.579 354.884 192.293 352.109 185.861L353.49 185.267C356.19 191.524 363.798 206.354 380.779 216.812C388.311 214.33 395.958 209.866 402.367 205.238C408.873 200.539 414.044 195.716 416.481 192.707L417.652 193.654C415.102 196.802 409.819 201.713 403.25 206.457Z",
    fill: "#299AFF"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M337.16 226.468C341.719 227.008 346.85 215.2 348.62 200.095C349.138 195.684 349.311 191.479 349.184 187.723C341.987 191.029 335.573 198.981 331.523 209.54C331.713 219.154 333.819 226.072 337.16 226.468Z",
    fill: "url(#paint92_linear)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M428.108 257.565C425.85 249.796 423.963 238.43 423.045 225.7C422.09 212.452 422.386 200.518 423.626 192.486C430.886 200.286 435.504 214.073 435.098 229.65C434.819 240.375 432.206 250.121 428.108 257.565Z",
    fill: "url(#paint93_linear)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M312.412 163.676C311.819 161.248 313.343 158.424 315.718 159.206C322.621 161.478 326.385 168.911 324.126 175.807C322.537 180.66 318.389 183.954 313.665 184.689C311.742 184.988 310.577 182.944 311.183 181.095C313.268 174.73 313.588 168.488 312.412 163.676Z",
    fill: "url(#paint94_linear)"
  })), _ellipse1 || (_ellipse1 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 18.8138,
    ry: 18.7926,
    transform: "matrix(-0.949869 -0.312649 -0.311331 0.950302 326.026 192.689)",
    fill: "url(#paint95_linear)"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.89868,
    ry: 7.97018,
    transform: "matrix(0.996387 -0.0811572 0.0833234 0.996838 337.109 192.112)",
    fill: "url(#paint96_radial)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M411.889 155.911C412.043 156.285 412.599 156.306 412.645 155.905C413.031 152.609 410.667 149.62 407.366 149.228C404.065 148.837 401.077 151.19 400.692 154.485C400.645 154.886 401.19 154.996 401.426 154.669C402.66 152.954 404.766 151.944 407.018 152.211C409.269 152.479 411.084 153.954 411.889 155.911Z",
    fill: "#003F66"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M384.579 154.266C384.47 154 384.075 153.985 384.041 154.27C383.767 156.612 385.447 158.735 387.792 159.014C390.137 159.292 392.261 157.62 392.534 155.279C392.568 154.994 392.18 154.916 392.012 155.148C391.136 156.366 389.639 157.084 388.04 156.894C386.441 156.704 385.151 155.656 384.579 154.266Z",
    fill: "#003F66"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M369.551 153.602C372.605 153.964 376.45 154.069 376.839 151.024C376.844 150.987 376.849 150.951 376.853 150.914C377.383 146.383 374.803 142.352 371.089 141.911C367.376 141.47 363.936 144.787 363.406 149.319C363.399 149.376 363.393 149.432 363.387 149.489C363.096 152.403 366.638 153.256 369.551 153.602Z",
    fill: "#003F66"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M397.641 219.19C397.325 219.152 397.034 218.996 396.836 218.754L388.591 208.771C386.431 206.154 386.875 202.364 389.581 200.324C390.889 199.34 392.529 198.906 394.201 199.104C395.874 199.302 397.37 200.108 398.414 201.371L399.565 202.765L401.007 201.679C402.315 200.694 403.956 200.26 405.629 200.458C407.3 200.657 408.797 201.462 409.84 202.725C412.002 205.343 411.558 209.132 408.852 211.173L398.527 218.956C398.277 219.144 397.959 219.227 397.641 219.19Z",
    fill: "#FF3E1D"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M362.361 183.996C362.774 184.045 363.069 184.419 363.02 184.831C362.526 189.046 361.611 199.434 361.893 207.279C361.908 207.694 361.584 208.042 361.169 208.056C360.754 208.07 360.406 207.746 360.391 207.331C360.104 199.372 361.03 188.896 361.527 184.654C361.576 184.242 361.949 183.947 362.361 183.996Z",
    fill: "#003F66"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M408.115 189.275C408.527 189.324 408.825 189.676 408.78 190.061C408.318 194.003 407.481 203.719 407.822 211.064C407.84 211.452 407.519 211.776 407.105 211.786C406.69 211.796 406.34 211.49 406.322 211.101C405.975 203.65 406.822 193.851 407.287 189.884C407.332 189.499 407.703 189.226 408.115 189.275Z",
    fill: "#003F66"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M391.991 116.859C392.068 112.328 394.498 108.15 395.712 106.604L396.897 107.532C395.798 108.933 393.566 112.801 393.496 116.888L391.991 116.859Z",
    fill: "#003F66"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.26676,
    ry: 5.26081,
    transform: "matrix(0.993048 0.117715 -0.116337 0.99321 361.539 210.377)",
    fill: "url(#paint97_linear)"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 6.01917,
    ry: 6.01236,
    transform: "matrix(0.993048 0.117715 -0.116337 0.99321 399.169 102.869)",
    fill: "url(#paint98_radial)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M407.405 210.763C403.374 210.286 399.724 213.163 399.252 217.19L399.118 218.331C399.118 218.332 399.118 218.333 399.118 218.334L398.5 223.605C398.24 225.824 399.831 227.837 402.053 228.101C402.465 228.15 402.839 227.855 402.887 227.443C402.936 227.031 402.64 226.657 402.228 226.608C400.831 226.442 399.831 225.177 399.995 223.782L400.512 219.365L400.746 217.367C401.121 214.164 404.024 211.876 407.23 212.256C410.436 212.636 412.73 215.541 412.355 218.743L412.222 219.883C412.222 219.885 412.221 219.886 412.221 219.887L411.604 225.158C411.44 226.553 410.176 227.55 408.779 227.384C408.367 227.336 407.993 227.63 407.945 228.042C407.896 228.455 408.192 228.828 408.604 228.877C410.826 229.141 412.838 227.555 413.098 225.335L413.615 220.918L413.615 220.918L413.849 218.92C414.321 214.893 411.436 211.241 407.405 210.763Z",
    fill: "#003F66"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 17.8226,
    ry: 9.36321,
    transform: "matrix(0.960404 -0.277486 0.279694 0.960416 378.982 130.517)",
    fill: "url(#paint99_radial)"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.32082,
    ry: 3.76444,
    transform: "matrix(0.777693 -0.627949 0.62984 0.777288 357.067 139.125)",
    fill: "url(#paint100_radial)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.8,
    filter: "url(#filter6_f)"
  }, _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M73 208L187.824 426H361.613L487 208H73Z",
    fill: "url(#paint101_linear)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.1,
    filter: "url(#filter7_f)"
  }, _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M-19.6159 173.144L112.112 410.521H311.485L455.331 173.144H-19.6159Z",
    fill: "url(#paint102_linear)"
  }))), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M113.965 298.852C117.369 296.886 121.563 296.886 124.968 298.852L144.934 310.379C148.338 312.345 150.435 315.977 150.435 319.908V342.963C150.435 346.894 148.338 350.526 144.934 352.492L124.968 364.019C121.563 365.984 117.369 365.984 113.965 364.019L93.999 352.492C90.5946 350.526 88.4975 346.894 88.4975 342.963V319.908C88.4975 315.977 90.5946 312.345 93.999 310.379L113.965 298.852Z",
    fill: "url(#paint103_linear)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 88,
    y: 297,
    width: 63,
    height: 69
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.965 298.852C117.369 296.886 121.563 296.886 124.968 298.852L144.934 310.379C148.338 312.345 150.435 315.977 150.435 319.908V342.963C150.435 346.894 148.338 350.526 144.934 352.492L124.968 364.019C121.563 365.984 117.369 365.984 113.965 364.019L93.999 352.492C90.5946 350.526 88.4975 346.894 88.4975 342.963V319.908C88.4975 315.977 90.5946 312.345 93.999 310.379L113.965 298.852Z",
    fill: "url(#paint104_linear)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.713 333.302C103.998 325.378 109.03 317.565 116.953 315.849C124.877 314.134 132.69 319.166 134.406 327.089L136.026 334.574L107.334 340.787L105.713 333.302Z",
    fill: "url(#paint105_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.101 313.422C106.283 315.548 100.048 325.23 102.173 335.047L104.179 344.309C104.18 344.318 104.181 344.328 104.183 344.337C104.46 345.617 112.644 344.932 122.462 342.807C132.28 340.681 140.014 337.92 139.737 336.639C139.736 336.634 139.735 336.63 139.733 336.625L139.735 336.625L137.727 327.35C135.601 317.532 125.919 311.296 116.101 313.422Z",
    fill: "url(#paint106_radial)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.68,
    cy: 337.681,
    rx: 14.6786,
    ry: 1.9146,
    transform: "rotate(-12.2164 121.68 337.681)",
    fill: "url(#paint107_linear)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.922,
    cy: 337.936,
    rx: 11.6941,
    ry: 1.29099,
    transform: "rotate(-12.2164 121.922 337.936)",
    fill: "url(#paint108_linear)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.958,
    cy: 340.474,
    rx: 18.1887,
    ry: 2.37244,
    transform: "rotate(-12.2164 121.958 340.474)",
    fill: "url(#paint109_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.651 341.247C137.726 341.131 137.754 341.022 137.733 340.923C137.487 339.79 130.861 340.264 122.933 341.98C115.004 343.697 108.776 346.007 109.021 347.139C109.043 347.239 109.113 347.326 109.23 347.401L109.085 347.432L113.842 369.405C115.558 377.333 123.377 382.369 131.306 380.653C139.234 378.936 144.27 371.117 142.553 363.189L137.796 341.216L137.651 341.247Z",
    fill: "url(#paint110_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.158 343.591C138.233 343.475 138.262 343.366 138.24 343.267C137.995 342.134 131.369 342.608 123.44 344.324C115.512 346.041 109.283 348.35 109.529 349.483C109.55 349.582 109.621 349.67 109.737 349.744L109.592 349.776L113.842 369.405C115.559 377.333 123.377 382.369 131.306 380.653C139.234 378.936 144.27 371.117 142.553 363.189L138.303 343.56L138.158 343.591Z",
    fill: "url(#paint111_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.108 340.066C139.191 339.934 139.221 339.81 139.197 339.696C138.916 338.398 131.55 338.891 122.745 340.798C113.939 342.704 107.029 345.302 107.31 346.6C107.335 346.713 107.414 346.814 107.544 346.9L107.383 346.935L112.363 369.937C114.269 378.742 122.953 384.335 131.758 382.429C140.563 380.522 146.156 371.839 144.249 363.034L139.269 340.032L139.108 340.066Z",
    fill: "url(#paint112_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.077 346.079C128.652 348.147 126.822 350.318 124.799 351.859L124.68 351.95L124.535 351.916C118.358 350.504 114.54 346.75 113.087 345.118L113.564 344.694C114.964 346.266 118.624 349.865 124.531 351.26C126.434 349.78 128.176 347.713 129.552 345.717C130.957 343.678 131.962 341.739 132.361 340.613L132.962 340.826C132.539 342.022 131.501 344.013 130.077 346.079Z",
    fill: "#299AFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.822 347.77C130.839 350.583 128.297 353.531 125.499 355.627L125.382 355.714L125.24 355.683C116.725 353.811 111.479 348.754 109.482 346.554L109.954 346.126C111.897 348.266 116.986 353.171 125.234 355.028C127.913 352.992 130.367 350.145 132.301 347.402C134.265 344.618 135.675 341.968 136.239 340.424L136.839 340.642C136.249 342.258 134.805 344.959 132.822 347.77Z",
    fill: "#299AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.072 364.925C110.977 364.513 111.412 359.06 110.045 352.746C109.646 350.902 109.137 349.188 108.569 347.697C106.135 350.019 104.654 354.099 104.481 358.901C105.879 362.738 107.677 365.227 109.072 364.925Z",
    fill: "url(#paint113_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.819 364.881C147.844 362.071 145.523 357.765 143.404 352.776C141.199 347.584 139.676 342.748 139.069 339.35C143.056 341.482 146.806 346.384 148.785 352.699C150.148 357.047 150.44 361.325 149.819 364.881Z",
    fill: "url(#paint114_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5517 347.118C93.8139 346.356 93.766 344.993 94.8026 344.769C97.8158 344.116 100.787 346.03 101.44 349.043C101.899 351.163 101.087 353.263 99.5162 354.548C98.8766 355.072 98.0122 354.573 97.8373 353.766C97.2352 350.985 96.0137 348.628 94.5517 347.118Z",
    fill: "url(#paint115_linear)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 7.97916,
    ry: 7.97917,
    transform: "matrix(-0.977355 0.211605 0.211605 0.977355 105.069 353.653)",
    fill: "url(#paint116_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.332 326.271C129.445 326.4 129.671 326.332 129.634 326.164C129.336 324.786 127.977 323.911 126.599 324.209C125.221 324.507 124.346 325.866 124.644 327.244C124.681 327.412 124.915 327.381 124.964 327.217C125.223 326.357 125.929 325.66 126.869 325.456C127.809 325.253 128.74 325.595 129.332 326.271Z",
    fill: "#003F66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.155 329.376C118.074 329.284 117.914 329.333 117.939 329.452C118.151 330.431 119.117 331.053 120.096 330.841C121.075 330.629 121.697 329.663 121.485 328.684C121.459 328.565 121.293 328.587 121.257 328.704C121.073 329.315 120.572 329.81 119.904 329.954C119.236 330.099 118.575 329.856 118.155 329.376Z",
    fill: "#003F66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.037 331.181C113.312 330.905 114.869 330.417 114.606 329.139C114.603 329.123 114.6 329.108 114.597 329.093C114.187 327.198 112.597 325.934 111.047 326.27C109.497 326.606 108.573 328.414 108.983 330.308C108.988 330.332 108.994 330.356 108.999 330.379C109.283 331.591 110.821 331.445 112.037 331.181Z",
    fill: "#003F66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.322 353.66C132.19 353.689 132.052 353.666 131.939 353.596L127.261 350.724C126.034 349.971 125.691 348.388 126.496 347.195C126.886 346.619 127.484 346.219 128.182 346.068C128.88 345.917 129.591 346.034 130.183 346.397L130.837 346.798L131.266 346.163C131.655 345.587 132.253 345.186 132.952 345.035C133.649 344.884 134.36 345.001 134.952 345.364C136.179 346.117 136.522 347.7 135.717 348.893L132.645 353.444C132.571 353.554 132.455 353.631 132.322 353.66Z",
    fill: "#FF3E1D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.337 344.385C113.509 344.347 113.679 344.457 113.716 344.629C114.098 346.391 115.159 350.691 116.352 353.804C116.415 353.968 116.332 354.153 116.168 354.216C116.003 354.279 115.819 354.196 115.756 354.032C114.546 350.874 113.476 346.537 113.092 344.764C113.055 344.592 113.164 344.422 113.337 344.385Z",
    fill: "#003F66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.408 340.198C132.581 340.161 132.749 340.261 132.783 340.422C133.14 342.07 134.141 346.089 135.288 348.993C135.349 349.146 135.264 349.32 135.099 349.382C134.934 349.443 134.752 349.368 134.691 349.215C133.527 346.269 132.519 342.215 132.16 340.557C132.125 340.396 132.236 340.235 132.408 340.198Z",
    fill: "#003F66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.98 313.323C115.388 311.492 115.789 309.478 116.063 308.689L116.665 308.899C116.417 309.613 116.054 311.476 116.587 313.127L115.98 313.323Z",
    fill: "#003F66"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.636,
    cy: 355.098,
    rx: 2.2337,
    ry: 2.2337,
    transform: "rotate(-12.2164 116.636 355.098)",
    fill: "url(#paint117_linear)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.934,
    cy: 306.712,
    rx: 2.5528,
    ry: 2.5528,
    transform: "rotate(-12.2164 116.934 306.712)",
    fill: "url(#paint118_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.081 348.931C133.398 349.295 132.329 350.955 132.693 352.637L132.797 353.114C132.797 353.114 132.797 353.115 132.797 353.115L133.274 355.318C133.475 356.245 134.389 356.834 135.317 356.633C135.489 356.596 135.598 356.426 135.561 356.254C135.524 356.082 135.354 355.972 135.182 356.01C134.599 356.136 134.024 355.766 133.898 355.183L133.498 353.337L133.317 352.502C133.027 351.164 133.877 349.844 135.216 349.555C136.554 349.265 137.874 350.115 138.163 351.453L138.266 351.93C138.267 351.93 138.267 351.931 138.267 351.931L138.744 354.133C138.87 354.716 138.5 355.291 137.917 355.418C137.744 355.455 137.635 355.625 137.672 355.797C137.709 355.969 137.879 356.079 138.052 356.041C138.979 355.841 139.568 354.926 139.367 353.998L138.968 352.153L138.968 352.153L138.787 351.318C138.423 349.635 136.763 348.567 135.081 348.931Z",
    fill: "#003F66"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 112.643,
    cy: 320.604,
    rx: 7.56005,
    ry: 3.97387,
    transform: "rotate(-35.113 112.643 320.604)",
    fill: "url(#paint119_radial)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.07841,
    ry: 3.38342,
    transform: "matrix(0.81802 -0.57519 0.575192 0.818019 108.997 351.059)",
    fill: "url(#paint120_radial)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.83426,
    ry: 1.59672,
    transform: "matrix(0.531317 -0.847173 0.847174 0.531316 105.041 327.085)",
    fill: "url(#paint121_radial)"
  }))), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.329 313.159L123.363 301.631C120.952 300.239 117.981 300.239 115.569 301.631L95.6036 313.159C93.1922 314.551 91.7067 317.124 91.7067 319.908V342.963C91.7067 345.747 93.1922 348.32 95.6036 349.712L115.569 361.24C117.981 362.632 120.952 362.632 123.363 361.24L143.329 349.712C145.74 348.32 147.226 345.747 147.226 342.963V319.908C147.226 317.124 145.74 314.551 143.329 313.159ZM124.968 298.852C121.563 296.886 117.369 296.886 113.965 298.852L93.999 310.379C90.5946 312.345 88.4975 315.977 88.4975 319.908V342.963C88.4975 346.894 90.5946 350.526 93.999 352.492L113.965 364.019C117.369 365.984 121.563 365.984 124.968 364.019L144.934 352.492C148.338 350.526 150.435 346.894 150.435 342.963V319.908C150.435 315.977 148.338 312.345 144.934 310.379L124.968 298.852Z",
    fill: "#E6F4FC"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 236.731,
    cy: 274.071,
    rx: 6.42558,
    ry: 6.42557,
    fill: "#BD6200"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 234.426,
    cy: 272.686,
    rx: 6.42558,
    ry: 6.42558,
    fill: "url(#paint122_linear)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 236.731,
    cy: 306.064,
    r: 6.42558,
    fill: "#BD6200"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 234.426,
    cy: 304.678,
    rx: 6.42558,
    ry: 6.42557,
    fill: "url(#paint123_linear)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.731,
    cy: 338.055,
    r: 6.42558,
    fill: "#BD6200"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 234.426,
    cy: 336.67,
    rx: 6.42558,
    ry: 6.42558,
    fill: "url(#paint124_linear)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M339.839 366.041V333.487L366.429 351.906L353.874 353.424L363.039 367.588L356.929 371.199L347.935 356.106L339.839 366.041Z",
    fill: "url(#paint125_linear)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 66,
    y: 156.778,
    width: 11,
    height: 11,
    transform: "rotate(-45 66 156.778)",
    fill: "#E6F4FC"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 430,
    y: 442,
    width: 11,
    height: 11,
    transform: "rotate(-90 430 442)",
    fill: "#E6F4FC"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 445,
    y: 271.778,
    width: 11,
    height: 11,
    transform: "rotate(-45 445 271.778)",
    fill: "#E6F4FC"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter8_f)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 337,
    cy: 91,
    r: 8,
    fill: "#FFF4E8"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter9_f)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 368,
    r: 14,
    fill: "#FFF4E8"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter10_f)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 416,
    cy: 402,
    r: 14,
    fill: "#FFF4E8"
  }))), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5023 156.994C49.834 161.865 40.0601 174.224 46.3107 184.695C54.124 197.784 77.4062 183.032 82.2629 199.12C87.1195 215.208 55.0527 213.654 62.4349 238.108C69.817 262.562 102.564 229.153 109.072 250.711C115.58 272.269 76.6165 266.477 83.8287 285.716",
    stroke: "url(#paint126_linear)",
    strokeWidth: 3
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M111.289 58.7787C117.564 59.5017 130.231 63.4859 130.699 73.6384C131.285 86.3291 107.961 86.9913 112.034 100.376C116.106 113.761 138.03 97.7308 144.22 118.075",
    stroke: "url(#paint127_linear)",
    strokeWidth: 3
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M479.039 275.554C481.894 282.267 485.285 296.874 476.012 301.596C464.422 307.499 450.666 283.946 440.387 293.701C430.108 303.456 457.511 319.155 441.887 333.982C426.263 348.81 411.808 305.994 398.035 319.066C384.261 332.137 419.066 348.226 405.601 359.151",
    stroke: "url(#paint128_linear)",
    strokeWidth: 3
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 349.5,
    r: 4.5,
    fill: "#FFF4E8"
  }))), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.3277 45.3989C84.3277 45.3989 81.836 46.2987 79.4135 48.9288C79.4135 48.9288 76.645 55.5042 85.4352 67.7551C94.2254 80.006 101.908 79.3139 101.908 79.3139C101.908 79.3139 105.576 77.6527 107.376 74.8149L84.3277 45.3989Z",
    fill: "url(#paint129_linear)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.3421 65.6095C82.3205 57.1653 80.5209 48.0983 84.3277 45.3989C88.1345 42.6303 96.1633 47.2677 102.185 55.7118C108.207 64.156 110.006 73.223 106.199 75.9224C102.393 78.6217 94.433 74.0536 88.3421 65.6095Z",
    fill: "url(#paint130_linear)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.4856 75.6455L93.1871 46.7832C93.1871 46.7832 89.3803 44.4299 87.4424 44.6376L93.9485 71.9079C93.9485 71.8387 96.9939 74.7457 99.4856 75.6455Z",
    fill: "#FBF9FA"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.3804 64.9173C84.1201 57.6498 82.3897 49.8286 85.2967 46.9216C85.4352 46.7832 85.5736 46.6448 85.7812 46.5063C89.2419 44.0146 96.5094 48.2367 102.047 55.8503C107.514 63.533 109.176 71.7695 105.715 74.2612C105.576 74.3997 105.369 74.4689 105.161 74.5381C101.424 76.4069 94.6406 72.254 89.3804 64.9173Z",
    fill: "url(#paint131_linear)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.3804 64.9173C84.1201 57.6498 82.3897 49.8286 85.2967 46.9216C88.9651 45.1221 95.7481 49.2749 101.008 56.6116C106.269 63.8791 107.999 71.7003 105.092 74.6073C101.424 76.4069 94.6406 72.254 89.3804 64.9173Z",
    fill: "url(#paint132_linear)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4568 54.9505C91.7336 54.812 91.5952 54.812 91.9413 54.7428C92.2873 54.6736 95.2636 56.1271 95.6788 56.1271L94.5714 56.8885C94.2946 56.8193 94.0869 56.8193 93.8793 56.8193C93.6716 56.8193 93.464 56.8885 93.3256 56.8885C93.1179 56.9577 92.9795 57.0269 92.7718 57.0961C92.5642 57.2345 92.495 57.5114 92.495 57.8575C92.495 58.2035 92.6334 58.5496 92.8411 58.8265C93.0487 59.1033 93.3256 59.3802 93.6024 59.5186C93.8793 59.657 94.1561 59.7955 94.433 59.8647C94.7098 59.9339 95.0559 60.0723 95.402 60.1415C95.748 60.2108 96.0941 60.3492 96.4402 60.4876C96.7863 60.626 97.1323 60.8337 97.4784 61.1105C97.8245 61.3874 98.1705 61.7335 98.5166 62.218C98.8627 62.7025 99.0703 63.1178 99.2088 63.533C99.3472 63.9483 99.4164 64.2944 99.4164 64.7097C99.4164 65.0557 99.3472 65.4018 99.278 65.6787C99.1395 65.9555 100.109 65.4018 99.9701 65.6095L102.946 69.6931L100.939 71.0774L98.1705 66.9937C98.1705 66.9937 98.0321 67.063 97.9629 67.1322C97.8245 67.2014 97.6861 67.2706 97.5476 67.3398C97.34 67.409 97.2015 67.409 96.9939 67.4782C96.7863 67.4782 96.5786 67.4782 96.3018 67.409L94.7791 65.125C95.1251 65.1942 95.402 65.1942 95.6788 65.1942C95.9557 65.1942 96.1633 65.125 96.371 65.0557C96.5786 64.9865 96.7863 64.9173 96.9939 64.7789C97.1323 64.3636 97.0631 63.8791 96.7171 63.3946C96.5786 63.187 96.371 62.9793 96.0941 62.8409C95.8173 62.7025 95.5404 62.564 95.1943 62.4948C94.8483 62.3564 94.5022 62.2872 94.1561 62.1488C93.8101 62.0103 93.3948 61.8719 93.0487 61.6643C92.6334 61.4566 92.2873 61.249 91.9413 60.9029C91.5952 60.626 91.1799 60.2108 90.9031 59.7263C90.3493 58.9649 90.0725 58.2035 90.0033 57.5114C89.9341 56.8193 90.0725 56.1963 90.4186 55.7118L87.5116 51.7666L88.619 51.0053L91.4568 54.9505Z",
    fill: "url(#paint133_linear)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0797 54.2583C92.3566 54.1199 92.6334 53.9815 92.9795 53.9123C93.3256 53.843 93.7408 53.7738 94.1561 53.7046L95.6788 56.0579C95.402 55.9887 95.1943 55.9887 94.9867 55.9887C94.7791 55.9887 94.5714 56.0579 94.433 56.0579C94.2253 56.1271 94.0869 56.1963 93.8793 56.2655C93.6716 56.404 93.6024 56.6808 93.6024 57.0269C93.6024 57.373 93.7408 57.719 93.9485 57.9959C94.1561 58.2728 94.433 58.5496 94.7098 58.688C94.9867 58.8265 95.2635 58.9649 95.5404 59.0341C95.8173 59.1033 96.1633 59.2418 96.5094 59.311C96.8555 59.3802 97.2016 59.5186 97.5476 59.657C97.8937 59.7955 98.2398 60.0031 98.5858 60.28C98.9319 60.5568 99.278 60.9029 99.624 61.3874C99.9701 61.8719 100.178 62.2872 100.316 62.7025C100.455 63.1178 100.524 63.4638 100.524 63.8791C100.524 64.2252 100.455 64.5712 100.385 64.8481C100.247 65.125 100.109 65.4018 99.9701 65.6095L102.946 69.6931L102.047 70.316L99.278 66.2324C99.278 66.2324 99.1395 66.3016 99.0703 66.3708C98.9319 66.44 98.7935 66.5092 98.655 66.5785C98.4474 66.6477 98.309 66.6477 98.1013 66.7169C97.8937 66.7169 97.6861 66.7169 97.4092 66.6477L95.8865 64.3636C96.2325 64.4328 96.5094 64.4328 96.7863 64.4328C97.0631 64.4328 97.2708 64.3636 97.4784 64.2944C97.686 64.2252 97.8937 64.156 98.1013 64.0175C98.2398 63.6023 98.1705 63.1178 97.8245 62.6333C97.686 62.4256 97.4784 62.218 97.2016 62.0795C96.9247 61.9411 96.6478 61.8027 96.3018 61.7335C95.9557 61.595 95.6096 61.5258 95.2636 61.3874C94.9175 61.249 94.5022 61.1105 94.1561 60.9029C93.7408 60.6953 93.3948 60.4876 93.0487 60.1415C92.7026 59.8647 92.2873 59.4494 92.0105 58.9649C91.4568 58.2035 91.1799 57.4422 91.1107 56.75C91.0415 56.0579 91.1799 55.435 91.526 54.9505L88.619 51.0053L89.5188 50.3823L92.0797 54.2583Z",
    fill: "url(#paint134_linear)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8865 64.2944L94.7791 65.0557L96.3018 67.3398L97.34 66.5785L95.8865 64.2944Z",
    fill: "#FA5866"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3493 55.7118L91.4568 54.9505L88.5498 51.0053L87.4424 51.7666L90.3493 55.7118Z",
    fill: "#FA5866"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1706 66.9937L99.278 66.1632L102.047 70.2468L100.939 71.0774L98.1706 66.9937Z",
    fill: "#FA5866"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4856 75.6455L96.371 77.8604C96.371 77.8604 93.464 76.6837 90.8339 74.0536L93.8793 71.9079C93.9485 71.8387 96.9247 74.7457 99.4856 75.6455Z",
    fill: "#FFF3AF"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5974 48.2367L79.0674 50.7976C79.0674 50.7976 78.929 52.3203 79.1367 53.6354L82.4589 51.8358C82.4589 51.8358 82.1129 49.621 82.5974 48.2367Z",
    fill: "#FFF3AF"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.137 69.4162C108.137 69.4162 106.476 72.4617 107.584 74.1228C107.653 74.192 108.622 72.1156 108.137 69.4162Z",
    fill: "#FBF9B8"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.649 27.2201C150.649 27.2201 148.711 27.4278 146.427 28.9505C146.427 28.9505 143.243 33.2418 147.534 43.7623C151.825 54.2829 157.57 55.0442 157.57 55.0442C157.57 55.0442 160.546 54.4905 162.346 52.691L150.649 27.2201Z",
    fill: "url(#paint135_linear)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.095 42.7241C147.119 35.5258 147.396 28.5352 150.649 27.2201C153.902 25.9051 158.954 30.6116 161.931 37.8791C164.907 45.0774 164.63 52.068 161.377 53.3831C158.124 54.6982 153.071 49.9916 150.095 42.7241Z",
    fill: "url(#paint136_linear)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.463 51.9988L156.809 29.7811C156.809 29.7811 154.455 27.3586 153.002 27.2201L153.071 48.3305C153.071 48.2612 154.801 50.9606 156.463 51.9988Z",
    fill: "#FBF9FA"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.925 42.4473C148.365 36.218 148.434 30.1963 150.995 28.5352C151.133 28.466 151.272 28.3968 151.41 28.3276C154.386 27.0817 158.954 31.4422 161.654 38.0175C164.353 44.5929 164.145 50.8914 161.169 52.1372C161.031 52.2065 160.892 52.2065 160.754 52.2757C157.778 52.8986 153.486 48.6765 150.925 42.4473Z",
    fill: "url(#paint137_linear)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.925 42.4473C148.365 36.218 148.434 30.1963 150.995 28.5352C153.971 27.8431 158.262 32.0651 160.823 38.3636C163.384 44.5929 163.315 50.6145 160.754 52.2757C157.778 52.8986 153.486 48.6765 150.925 42.4473Z",
    fill: "url(#paint138_linear)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M154.179 35.4566C154.386 35.3874 154.317 35.3874 154.594 35.3874C154.871 35.3874 156.809 36.9793 157.086 37.0486L156.117 37.4638C155.978 37.3946 155.77 37.3254 155.632 37.3254C155.494 37.3254 155.286 37.3254 155.217 37.3254C155.078 37.3254 154.94 37.3254 154.801 37.3946C154.663 37.4638 154.525 37.6715 154.455 37.8791C154.386 38.156 154.455 38.3636 154.525 38.7097C154.663 38.9866 154.801 39.1942 154.94 39.3326C155.078 39.471 155.286 39.6095 155.494 39.7479C155.701 39.8863 155.909 39.9555 156.117 40.094C156.324 40.2324 156.601 40.3708 156.809 40.5093C157.016 40.6477 157.293 40.8553 157.501 41.1322C157.708 41.409 157.916 41.6859 158.055 42.1012C158.193 42.5165 158.331 42.8625 158.331 43.1394C158.331 43.4855 158.331 43.7623 158.262 44.0392C158.193 44.316 158.124 44.5237 157.985 44.7313C157.847 44.939 158.677 44.7313 158.47 44.8005L159.993 48.3305L158.331 49.0226L157.016 45.5619C157.016 45.5619 156.947 45.5619 156.809 45.6311C156.739 45.6311 156.601 45.7003 156.463 45.7003C156.324 45.7003 156.186 45.7003 155.978 45.7003C155.84 45.7003 155.632 45.6311 155.494 45.5619L154.801 43.6239C155.009 43.6931 155.286 43.7623 155.494 43.8315C155.701 43.8315 155.909 43.8315 156.047 43.8315C156.255 43.8315 156.393 43.7623 156.532 43.7623C156.739 43.4855 156.739 43.1394 156.601 42.7241C156.532 42.5165 156.393 42.378 156.255 42.2396C156.117 42.1012 155.909 41.9628 155.701 41.8243C155.494 41.6859 155.217 41.5475 155.009 41.409C154.732 41.2706 154.525 41.063 154.248 40.8553C153.971 40.6477 153.763 40.3708 153.556 40.094C153.348 39.8171 153.14 39.4711 153.002 39.0558C152.725 38.3636 152.656 37.8099 152.725 37.2562C152.794 36.7025 153.002 36.2872 153.348 36.0103L151.894 32.6188L152.863 32.2036L154.179 35.4566Z",
    fill: "url(#paint139_linear)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M154.732 35.1106C154.94 35.0413 155.148 35.0413 155.424 35.0413C155.701 35.0413 155.978 35.0413 156.324 35.1106L157.016 37.1178C156.878 37.0486 156.67 36.9793 156.532 36.9793C156.393 36.9793 156.186 36.9793 156.117 36.9793C155.978 36.9793 155.84 36.9793 155.701 37.0485C155.563 37.1178 155.424 37.3254 155.355 37.533C155.286 37.8099 155.355 38.0175 155.424 38.3636C155.563 38.6405 155.701 38.8481 155.84 38.9865C155.978 39.125 156.186 39.2634 156.393 39.4018C156.601 39.5403 156.809 39.6095 157.016 39.7479C157.224 39.8863 157.501 40.0248 157.708 40.1632C157.916 40.3016 158.193 40.5093 158.401 40.7861C158.608 41.063 158.816 41.3398 158.954 41.7551C159.093 42.1704 159.231 42.5165 159.231 42.7933C159.231 43.1394 159.231 43.4163 159.162 43.6931C159.093 43.97 159.024 44.1776 158.885 44.3853C158.747 44.5929 158.608 44.7313 158.47 44.8698L159.993 48.3997L159.231 48.6765L157.916 45.2158C157.916 45.2158 157.847 45.2158 157.708 45.285C157.639 45.285 157.501 45.3543 157.362 45.3543C157.224 45.3543 157.086 45.3543 156.878 45.3543C156.739 45.3543 156.532 45.285 156.393 45.2158L155.701 43.2778C155.909 43.347 156.186 43.4163 156.393 43.4855C156.601 43.4855 156.809 43.4855 156.947 43.4855C157.155 43.4855 157.293 43.4163 157.432 43.4163C157.639 43.1394 157.639 42.7933 157.501 42.378C157.432 42.1704 157.293 42.032 157.155 41.8935C157.016 41.7551 156.809 41.6167 156.601 41.4783C156.393 41.3398 156.117 41.2014 155.909 41.063C155.632 40.9245 155.424 40.7169 155.148 40.5093C154.871 40.3016 154.663 40.0248 154.455 39.7479C154.248 39.471 154.04 39.125 153.902 38.7097C153.625 38.0175 153.556 37.4638 153.625 36.9101C153.694 36.3564 153.902 35.9411 154.248 35.6643L152.794 32.2728L153.556 31.9959L154.732 35.1106Z",
    fill: "url(#paint140_linear)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M155.77 43.0702L154.871 43.4855L155.563 45.4235L156.463 45.0082L155.77 43.0702Z",
    fill: "#FA5866"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M153.21 35.8719L154.179 35.4566L152.725 32.0651L151.756 32.4804L153.21 35.8719Z",
    fill: "#FA5866"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M157.016 45.4235L157.985 45.0774L159.3 48.5381L158.331 48.8842L157.016 45.4235Z",
    fill: "#FA5866"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M156.463 51.9988L153.832 53.1062C153.832 53.1062 151.894 51.7219 150.441 49.3687L153.071 48.3305C153.071 48.2612 154.732 50.9606 156.463 51.9988Z",
    fill: "#FFF3AF"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M148.849 29.0197L145.804 30.2656C145.804 30.2656 145.458 31.373 145.388 32.342L148.157 31.6498C148.088 31.6498 148.226 29.9887 148.849 29.0197Z",
    fill: "#FFF3AF"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.869 48.9534C163.869 48.9534 162.138 50.8914 162.692 52.3449C162.692 52.3449 163.799 51.0298 163.869 48.9534Z",
    fill: "#FBF9B8"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M355.819 102.795C355.819 102.795 357.232 104.137 359.872 104.89C359.872 104.89 365.204 104.535 370.437 94.4494C375.67 84.3641 372.527 79.4951 372.527 79.4951C372.527 79.4951 370.177 77.5869 367.64 77.3822L355.819 102.795Z",
    fill: "url(#paint141_linear)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.987 93.1715C364.432 100.102 358.928 104.421 355.819 102.795C352.709 101.17 353.02 94.2715 356.627 87.2956C360.182 80.3647 365.686 76.046 368.795 77.6718C371.905 79.2976 371.594 86.1957 367.987 93.1715Z",
    fill: "url(#paint142_linear)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370.925 82.3118L353.778 96.444C353.778 96.444 353.457 99.8061 354.294 101.003L370.329 87.272C370.276 87.3168 371.211 84.2498 370.925 82.3118Z",
    fill: "#FBF9FA"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.238 92.7183C364.152 98.7051 359.521 102.554 356.596 101.68C356.454 101.619 356.311 101.558 356.169 101.498C353.291 100.038 353.653 93.7333 356.912 87.4168C360.172 81.1003 365.104 77.1775 367.981 78.6372C368.123 78.6978 368.213 78.8032 368.356 78.8638C370.758 80.7272 370.323 86.7314 367.238 92.7183Z",
    fill: "url(#paint143_linear)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.238 92.7183C364.152 98.7051 359.521 102.554 356.596 101.68C354.14 99.8612 354.576 93.8569 357.714 87.8252C360.799 81.8384 365.431 77.9895 368.356 78.8638C370.758 80.7272 370.323 86.7314 367.238 92.7183Z",
    fill: "url(#paint144_linear)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M359.805 94.7699C359.618 94.6566 359.663 94.7093 359.483 94.4984C359.304 94.2876 359.261 91.7799 359.134 91.5242L360.078 91.9932C360.115 92.1435 360.197 92.3465 360.287 92.4519C360.376 92.5574 360.511 92.7155 360.556 92.7683C360.645 92.8737 360.735 92.9791 360.878 93.0397C361.02 93.1003 361.268 93.0712 361.471 92.9894C361.727 92.8627 361.84 92.6755 362.059 92.3985C362.18 92.1137 362.248 91.8737 362.264 91.6786C362.28 91.4835 362.251 91.2356 362.222 90.9878C362.193 90.7399 362.111 90.5369 362.082 90.289C362.052 90.0412 361.979 89.7406 361.949 89.4928C361.92 89.2449 361.899 88.8995 361.975 88.5619C362.052 88.2244 362.128 87.8868 362.355 87.5123C362.581 87.1378 362.755 86.8081 362.966 86.6288C363.23 86.4045 363.441 86.2251 363.696 86.0985C363.952 85.9718 364.155 85.89 364.403 85.8609C364.651 85.8318 363.955 85.3337 364.142 85.447L365.844 82L367.447 82.8168L365.663 86.0608C365.663 86.0608 365.708 86.1135 365.851 86.1741C365.896 86.2268 366.038 86.2874 366.128 86.3929C366.217 86.4983 366.307 86.6037 366.442 86.7619C366.531 86.8673 366.613 87.0704 366.65 87.2206L365.622 89.0035C365.541 88.8005 365.414 88.5448 365.332 88.3418C365.198 88.1836 365.063 88.0255 364.973 87.92C364.839 87.7619 364.696 87.7013 364.607 87.5959C364.261 87.6171 363.998 87.8413 363.771 88.2158C363.658 88.4031 363.642 88.5982 363.626 88.7934C363.61 88.9885 363.64 89.2363 363.669 89.4842C363.698 89.732 363.772 90.0326 363.801 90.2805C363.875 90.581 363.851 90.8737 363.872 91.2192C363.894 91.5646 363.817 91.9021 363.741 92.2397C363.665 92.5772 363.536 92.9596 363.309 93.3341C362.961 93.9935 362.584 94.405 362.118 94.711C361.651 95.0171 361.2 95.128 360.765 95.0438L359.123 98.3484L358.179 97.8794L359.805 94.7699Z",
    fill: "url(#paint145_linear)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M359.183 94.5724C358.995 94.4591 358.861 94.3009 358.681 94.09C358.502 93.8791 358.323 93.6683 358.151 93.3598L359.232 91.5321C359.269 91.6824 359.35 91.8854 359.44 91.9908C359.53 92.0963 359.664 92.2544 359.709 92.3071C359.799 92.4126 359.889 92.518 360.031 92.5786C360.173 92.6392 360.421 92.6101 360.624 92.5283C360.88 92.4016 360.993 92.2143 361.212 91.9374C361.333 91.6526 361.402 91.4126 361.417 91.2175C361.433 91.0223 361.404 90.7745 361.375 90.5266C361.346 90.2788 361.264 90.0758 361.235 89.8279C361.206 89.5801 361.132 89.2795 361.103 89.0316C361.074 88.7838 361.053 88.4384 361.129 88.1008C361.205 87.7633 361.282 87.4257 361.508 87.0512C361.735 86.6767 361.909 86.347 362.12 86.1676C362.383 85.9434 362.594 85.764 362.85 85.6373C363.106 85.5107 363.309 85.4289 363.556 85.3998C363.804 85.3707 363.999 85.3864 364.194 85.4022L365.897 81.9551L366.601 82.3557L364.817 85.5997C364.817 85.5997 364.862 85.6524 365.004 85.713C365.049 85.7657 365.191 85.8263 365.281 85.9317C365.371 86.0372 365.46 86.1426 365.595 86.3008C365.685 86.4062 365.767 86.6092 365.803 86.7595L364.776 88.5424C364.694 88.3394 364.567 88.0837 364.485 87.8807C364.351 87.7225 364.216 87.5644 364.127 87.4589C363.992 87.3008 363.85 87.2402 363.76 87.1347C363.415 87.156 363.151 87.3802 362.924 87.7547C362.811 87.942 362.795 88.1371 362.78 88.3322C362.764 88.5274 362.793 88.7752 362.822 89.0231C362.851 89.2709 362.925 89.5715 362.954 89.8193C363.028 90.1199 363.005 90.4126 363.026 90.758C363.047 91.1035 362.971 91.441 362.894 91.7786C362.818 92.1161 362.689 92.4985 362.462 92.873C362.114 93.5323 361.738 93.9438 361.271 94.2499C360.804 94.5559 360.353 94.6669 359.918 94.5826L358.277 97.8872L357.573 97.4867L359.183 94.5724Z",
    fill: "url(#paint146_linear)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M364.573 88.6242L365.472 89.0405L366.5 87.2576L365.6 86.8413L364.573 88.6242Z",
    fill: "#FA5866"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M360.749 95.2389L359.805 94.7699L358.164 98.0745L359.108 98.5435L360.749 95.2389Z",
    fill: "#FA5866"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M365.558 86.1505L364.667 85.6367L366.45 82.3926L367.342 82.9065L365.558 86.1505Z",
    fill: "#FA5866"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M370.925 82.3118L373.473 83.5977C373.473 83.5977 373.674 85.9707 372.823 88.6026L370.329 87.272C370.276 87.3168 371.256 84.3025 370.925 82.3118Z",
    fill: "#FFF3AF"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M358.355 103L361.277 104.513C361.277 104.513 362.345 104.059 363.128 103.483L360.807 101.823C360.852 101.876 359.497 102.847 358.355 103Z",
    fill: "#FFF3AF"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M363.807 78.6441C363.807 78.6441 366.404 78.7063 367.153 77.3428C367.153 77.3428 365.433 77.3514 363.807 78.6441Z",
    fill: "#FBF9B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    x: 74,
    y: 394,
    width: 24,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f",
    x: 328.798,
    y: 81.0478,
    width: 140.534,
    height: 204.455,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f",
    x: 111.941,
    y: 26.2302,
    width: 289.588,
    height: 340.775,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f",
    x: 98.0089,
    y: 120.948,
    width: 337.447,
    height: 279.332,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f",
    x: 62.6739,
    y: 417.562,
    width: 385.094,
    height: 116.917,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f",
    x: 12.2543,
    y: 147.167,
    width: 482.907,
    height: 261.692,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f",
    x: 65,
    y: 200,
    width: 430,
    height: 234,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f",
    x: -35.6159,
    y: 157.144,
    width: 506.947,
    height: 269.378,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f",
    x: 325,
    y: 79,
    width: 24,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f",
    x: 94,
    y: 350,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f",
    x: 398,
    y: 384,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f",
    x: 50,
    y: 341,
    width: 17,
    height: 17,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(448.528 343.66) rotate(3.76719) scale(16.243)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBD7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9829,
    stopColor: "#BDAFD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 426.454,
    y1: 331.5,
    x2: 426.851,
    y2: 325.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C73E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#A4152C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 409.975,
    y1: 408.246,
    x2: 415.432,
    y2: 325.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB934"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 443.408,
    y1: 410.448,
    x2: 448.647,
    y2: 330.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00198413,
    stopColor: "#C93347"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7527"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 405.956,
    y1: 387.739,
    x2: 417.655,
    y2: 343.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#E2DCEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 415.135,
    y1: 339.124,
    x2: 415.135,
    y2: 300.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#BD8BD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBD7E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 411.431,
    y1: 377.155,
    x2: 411.431,
    y2: 356.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00198414,
    stopColor: "#E03347"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6E27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 418.215,
    y1: 282.41,
    x2: 484.344,
    y2: 149.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 418.215,
    y1: 282.41,
    x2: 484.344,
    y2: 149.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 418.215,
    y1: 282.41,
    x2: 484.344,
    y2: 149.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 418.215,
    y1: 282.41,
    x2: 484.344,
    y2: 149.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 418.215,
    y1: 282.41,
    x2: 484.344,
    y2: 149.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 418.215,
    y1: 282.41,
    x2: 484.344,
    y2: 149.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 418.215,
    y1: 282.41,
    x2: 484.344,
    y2: 149.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 418.215,
    y1: 282.41,
    x2: 484.344,
    y2: 149.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 418.215,
    y1: 282.41,
    x2: 484.344,
    y2: 149.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 418.215,
    y1: 282.41,
    x2: 484.344,
    y2: 149.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 418.215,
    y1: 282.41,
    x2: 484.344,
    y2: 149.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 418.215,
    y1: 282.41,
    x2: 484.344,
    y2: 149.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 418.215,
    y1: 282.41,
    x2: 484.344,
    y2: 149.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 418.215,
    y1: 282.41,
    x2: 484.344,
    y2: 149.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 418.215,
    y1: 282.41,
    x2: 484.344,
    y2: 149.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 418.215,
    y1: 282.41,
    x2: 484.344,
    y2: 149.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 418.215,
    y1: 282.41,
    x2: 484.344,
    y2: 149.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 418.215,
    y1: 282.41,
    x2: 484.344,
    y2: 149.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 418.215,
    y1: 282.41,
    x2: 484.344,
    y2: 149.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: 418.215,
    y1: 282.41,
    x2: 484.344,
    y2: 149.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: 418.215,
    y1: 282.41,
    x2: 484.344,
    y2: 149.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: 418.215,
    y1: 282.41,
    x2: 484.344,
    y2: 149.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x1: 418.215,
    y1: 282.41,
    x2: 484.344,
    y2: 149.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear",
    x1: 418.215,
    y1: 282.41,
    x2: 484.344,
    y2: 149.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear",
    x1: 418.215,
    y1: 282.41,
    x2: 484.344,
    y2: 149.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear",
    x1: 418.215,
    y1: 282.41,
    x2: 484.344,
    y2: 149.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear",
    x1: 418.215,
    y1: 282.41,
    x2: 484.344,
    y2: 149.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear",
    x1: 302.185,
    y1: 374.114,
    x2: 399.845,
    y2: 113.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear",
    x1: 302.185,
    y1: 374.114,
    x2: 399.845,
    y2: 113.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear",
    x1: 302.185,
    y1: 374.114,
    x2: 399.845,
    y2: 113.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear",
    x1: 302.185,
    y1: 374.114,
    x2: 399.845,
    y2: 113.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear",
    x1: 302.185,
    y1: 374.114,
    x2: 399.845,
    y2: 113.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear",
    x1: 302.185,
    y1: 374.114,
    x2: 399.845,
    y2: 113.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear",
    x1: 302.185,
    y1: 374.114,
    x2: 399.845,
    y2: 113.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear",
    x1: 302.185,
    y1: 374.114,
    x2: 399.845,
    y2: 113.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear",
    x1: 302.185,
    y1: 374.114,
    x2: 399.845,
    y2: 113.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear",
    x1: 302.185,
    y1: 374.114,
    x2: 399.845,
    y2: 113.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear",
    x1: 302.185,
    y1: 374.114,
    x2: 399.845,
    y2: 113.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear",
    x1: 302.185,
    y1: 374.114,
    x2: 399.845,
    y2: 113.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear",
    x1: 302.185,
    y1: 374.114,
    x2: 399.845,
    y2: 113.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear",
    x1: 302.185,
    y1: 374.114,
    x2: 399.845,
    y2: 113.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear",
    x1: 302.185,
    y1: 374.114,
    x2: 399.845,
    y2: 113.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear",
    x1: 302.185,
    y1: 374.114,
    x2: 399.845,
    y2: 113.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear",
    x1: 302.185,
    y1: 374.114,
    x2: 399.845,
    y2: 113.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear",
    x1: 302.185,
    y1: 374.114,
    x2: 399.845,
    y2: 113.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear",
    x1: 302.185,
    y1: 374.114,
    x2: 399.845,
    y2: 113.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear",
    x1: 302.185,
    y1: 374.114,
    x2: 399.845,
    y2: 113.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear",
    x1: 302.185,
    y1: 374.114,
    x2: 399.845,
    y2: 113.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear",
    x1: 302.185,
    y1: 374.114,
    x2: 399.845,
    y2: 113.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear",
    x1: 302.185,
    y1: 374.114,
    x2: 399.845,
    y2: 113.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear",
    x1: 320.253,
    y1: 402.441,
    x2: 374.983,
    y2: 182.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear",
    x1: 317.522,
    y1: 524.834,
    x2: 323.634,
    y2: 443.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear",
    x1: 119.672,
    y1: 164.618,
    x2: 349.347,
    y2: 367.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3CB8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear",
    x1: 116.006,
    y1: 456.055,
    x2: 428.075,
    y2: 465.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22ABFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004F80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear",
    x1: 137.236,
    y1: 353.877,
    x2: 364.378,
    y2: 205.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007ECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002439"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear",
    x1: 125.234,
    y1: 182.366,
    x2: 372.241,
    y2: 199.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00101A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004871"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear",
    x1: 125.234,
    y1: 176.346,
    x2: 372.331,
    y2: 192.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66C8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear",
    x1: 211.171,
    y1: 297.044,
    x2: 108.878,
    y2: 458.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CB8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F6FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear",
    x1: 311.685,
    y1: 373.724,
    x2: 311.685,
    y2: 384.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84D3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A2FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear",
    x1: 121.043,
    y1: 388.775,
    x2: 121.043,
    y2: 400.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84D3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A2FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear",
    x1: 100.642,
    y1: 409.002,
    x2: 126.705,
    y2: 422.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CBEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear",
    x1: 181.078,
    y1: 405.916,
    x2: 181.078,
    y2: 419.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84D3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A2FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear",
    x1: 231.608,
    y1: 425.573,
    x2: 231.608,
    y2: 441.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84D3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A2FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear",
    x1: 388.283,
    y1: 428.707,
    x2: 417.427,
    y2: 442.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CBEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear",
    x1: 253.708,
    y1: 151.167,
    x2: 257.24,
    y2: 387.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79624,
    stopColor: "#FFF7AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7AA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear",
    x1: 318.842,
    y1: 181.794,
    x2: 338.457,
    y2: 364.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.47199,
    stopColor: "#B3E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear",
    x1: 318.842,
    y1: 181.064,
    x2: 337.246,
    y2: 358.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.47199,
    stopColor: "#B3E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear",
    x1: 311.682,
    y1: 279.769,
    x2: 332.538,
    y2: 356.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.47199,
    stopColor: "#51B6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932292,
    stopColor: "#0A98EB",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0093E8",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear",
    x1: 166.487,
    y1: 90.8622,
    x2: 151.369,
    y2: 100.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCAAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear",
    x1: 181.15,
    y1: 114.355,
    x2: 138.653,
    y2: 147.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCAAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear",
    x1: 240.5,
    y1: 160,
    x2: 240.5,
    y2: 259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B4DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0848C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear",
    x1: 241.043,
    y1: 158.445,
    x2: 241.043,
    y2: 258.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0AD3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E7FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear",
    x1: 239.957,
    y1: 160.166,
    x2: 239.957,
    y2: 258.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB84C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear",
    x1: 263.744,
    y1: 70.3198,
    x2: 219.054,
    y2: 147.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCAAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear",
    x1: 281.278,
    y1: 51.7825,
    x2: 222.433,
    y2: 65.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0068A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003A5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear",
    x1: 228.14,
    y1: 90.2373,
    x2: 223.114,
    y2: 107.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCAAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear",
    x1: 314.116,
    y1: 228.266,
    x2: 314.116,
    y2: 359.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003F66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.939352,
    stopColor: "#003F66",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear",
    x1: 370.728,
    y1: 127.774,
    x2: 413.331,
    y2: 176.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFF5FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(367.895 126.669) rotate(48.1361) scale(84.0737 111.795)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542736,
    stopColor: "white",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear",
    x1: 10.1537,
    y1: 1.24599,
    x2: 60.2805,
    y2: 9.89147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3DDF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear",
    x1: 8.0893,
    y1: 0.840218,
    x2: 47.5731,
    y2: 8.8856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CB8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F6FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear",
    x1: 29.2959,
    y1: 0.151051,
    x2: 79.3327,
    y2: 14.3119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6ECAFF",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFF3FF",
    stopOpacity: 0.88
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear",
    x1: 350.208,
    y1: 184.844,
    x2: 412.116,
    y2: 206.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.116469,
    stopColor: "#FFAA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699803,
    stopColor: "#FFD84F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF911C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear",
    x1: 362.889,
    y1: 200.786,
    x2: 425.679,
    y2: 245.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFF5FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(363.565 198.076) rotate(61.0436) scale(96.9748 123.148)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542736,
    stopColor: "white",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear",
    x1: 342.173,
    y1: 186.892,
    x2: 337.481,
    y2: 226.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear",
    x1: 429.474,
    y1: 192.647,
    x2: 427.691,
    y2: 257.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAD55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear",
    x1: 324.31,
    y1: 175.247,
    x2: 309.487,
    y2: 170.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAD55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear",
    x1: 18.8138,
    y1: 0,
    x2: 18.8138,
    y2: 37.5851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAD55"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.07695 4.58163) rotate(48.7358) scale(14.2382 16.5157)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear",
    x1: 1.40383,
    y1: 4.42541,
    x2: 11.3859,
    y2: 6.58905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003F66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CA8FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint98_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.04768 7.95987) rotate(-13.9685) scale(10.2713 10.2611)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.289047,
    stopColor: "#8C4300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC68"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint99_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.26039 3.25069) rotate(29.3176) scale(30.0313 34.424)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542736,
    stopColor: "white",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint100_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.0026 1.30693) rotate(42.9628) scale(8.67472 11.6159)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542736,
    stopColor: "white",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear",
    x1: 280,
    y1: 208,
    x2: 282.992,
    y2: 410.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79624,
    stopColor: "#FFF7AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7AA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear",
    x1: 217.858,
    y1: 173.144,
    x2: 220.95,
    y2: 394.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79624,
    stopColor: "#FFF7AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7AA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear",
    x1: 101.128,
    y1: 308.512,
    x2: 134.137,
    y2: 357.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CBEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear",
    x1: 101.128,
    y1: 308.512,
    x2: 134.137,
    y2: 357.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55C1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1154FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear",
    x1: 108.956,
    y1: 320.641,
    x2: 132.796,
    y2: 334.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFF5FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint106_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(107.667 320.588) rotate(29.2422) scale(35.6584 47.504)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542736,
    stopColor: "white",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear",
    x1: 111.306,
    y1: 336.295,
    x2: 132.56,
    y2: 339.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3DDF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear",
    x1: 113.657,
    y1: 337.002,
    x2: 130.398,
    y2: 340.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CB8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F6FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear",
    x1: 116.19,
    y1: 338.165,
    x2: 137.407,
    y2: 344.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6ECAFF",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFF3FF",
    stopOpacity: 0.88
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear",
    x1: 108.577,
    y1: 346.403,
    x2: 136.332,
    y2: 346.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.116469,
    stopColor: "#FFAA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699803,
    stopColor: "#FFD84F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF911C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear",
    x1: 115.857,
    y1: 351.059,
    x2: 147.172,
    y2: 360.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFF5FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint112_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(115.755 349.876) rotate(42.161) scale(41.148 52.3057)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542736,
    stopColor: "white",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear",
    x1: 105.641,
    y1: 348.331,
    x2: 109.226,
    y2: 364.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear",
    x1: 141.438,
    y1: 338.607,
    x2: 149.688,
    y2: 364.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAD55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear",
    x1: 101.387,
    y1: 348.798,
    x2: 94.9193,
    y2: 350.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAD55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear",
    x1: 7.97916,
    y1: 0,
    x2: 7.97916,
    y2: 15.9583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAD55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear",
    x1: 114.997,
    y1: 354.743,
    x2: 119.231,
    y2: 355.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003F66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CA8FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint118_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(115.25 307.539) rotate(-13.9837) scale(4.35648)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.289047,
    stopColor: "#8C4300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC68"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint119_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(108.587 318.01) rotate(29.3309) scale(12.7404 14.6081)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542736,
    stopColor: "white",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint120_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.0326483 1.94495) rotate(48.7512) scale(6.04285 7.00894)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint121_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.850141 0.554346) rotate(42.9388) scale(3.68113 4.92891)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542736,
    stopColor: "white",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear",
    x1: 234.426,
    y1: 266.26,
    x2: 234.426,
    y2: 279.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB84C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear",
    x1: 234.426,
    y1: 298.253,
    x2: 234.426,
    y2: 311.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB84C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear",
    x1: 234.426,
    y1: 330.245,
    x2: 234.426,
    y2: 343.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB84C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear",
    x1: 353.134,
    y1: 333.487,
    x2: 353.134,
    y2: 371.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38BC48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83F38D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear",
    x1: 50.5834,
    y1: 158.479,
    x2: 116.987,
    y2: 320.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6F4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F4FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear",
    x1: 115.455,
    y1: 57.511,
    x2: 126.453,
    y2: 114.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF2D2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear",
    x1: 482.576,
    y1: 279.281,
    x2: 367.556,
    y2: 371.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6F4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F4FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear",
    x1: 79.8402,
    y1: 48.2144,
    x2: 102.151,
    y2: 79.3639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0351351,
    stopColor: "#FFE6B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2614,
    stopColor: "#FF9C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBD59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear",
    x1: 84.3593,
    y1: 45.3744,
    x2: 106.232,
    y2: 75.9123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD328"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear",
    x1: 85.7384,
    y1: 46.5519,
    x2: 105.622,
    y2: 74.3131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0351351,
    stopColor: "#FF8447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2614,
    stopColor: "#ED3D47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8427"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear",
    x1: 85.2778,
    y1: 46.9499,
    x2: 105.097,
    y2: 74.6211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear",
    x1: 102.152,
    y1: 70.2281,
    x2: 88.297,
    y2: 51.1714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0351351,
    stopColor: "#FF8447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2614,
    stopColor: "#ED3D47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8427"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear",
    x1: 102.773,
    y1: 69.7769,
    x2: 88.9175,
    y2: 50.7203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE685"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear",
    x1: 146.819,
    y1: 28.545,
    x2: 157.786,
    y2: 55.2073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0351351,
    stopColor: "#FFC047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2614,
    stopColor: "#EDD13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC327"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear",
    x1: 150.619,
    y1: 27.2445,
    x2: 161.371,
    y2: 53.3833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD328"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear",
    x1: 151.426,
    y1: 28.3447,
    x2: 161.2,
    y2: 52.1069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0351351,
    stopColor: "#FF8447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2614,
    stopColor: "#ED3D47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8427"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear",
    x1: 151.02,
    y1: 28.5568,
    x2: 160.763,
    y2: 52.2418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA928"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear",
    x1: 159.363,
    y1: 48.5168,
    x2: 152.502,
    y2: 32.1699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0351351,
    stopColor: "#FF8447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2614,
    stopColor: "#ED3D47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8427"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear",
    x1: 159.895,
    y1: 48.2934,
    x2: 153.034,
    y2: 31.9466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC85F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE992"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear",
    x1: 359.309,
    y1: 104.854,
    x2: 372.511,
    y2: 79.2246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0351351,
    stopColor: "#FFC047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2614,
    stopColor: "#EDD13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC327"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear",
    x1: 355.856,
    y1: 102.802,
    x2: 368.799,
    y2: 77.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD328"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear",
    x1: 356.171,
    y1: 101.474,
    x2: 367.938,
    y2: 78.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0351351,
    stopColor: "#FF8447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2614,
    stopColor: "#ED3D47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8427"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear",
    x1: 356.596,
    y1: 101.646,
    x2: 368.324,
    y2: 78.879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA928"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear",
    x1: 366.394,
    y1: 82.3587,
    x2: 358.388,
    y2: 98.1764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0351351,
    stopColor: "#FF8447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2614,
    stopColor: "#ED3D47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8427"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear",
    x1: 365.879,
    y1: 82.0981,
    x2: 357.873,
    y2: 97.9157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC85F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE992"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 518,
    height: 556,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 304,
    height: 302,
    fill: "white",
    transform: "translate(58 52)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignInUp);
export default __webpack_public_path__ + "static/media/Sign_in_up.879ccd1e482ed895b823981a557777b1.svg";
export { ForwardRef as ReactComponent };